<!-- <p>add-customer works!</p> -->

<!-- <main id="main" class="main"><div class="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1"> -->

<main class="main" id="main">
  <div class="container" id="container">
    <div class="">
      <div class="">
        <div class="headertabs">
          <div class="row bg-white">

            <!-- <div class="col-12 text-end">
            <img class="cartlogo" src="./../../assets/img/logo/cart.png" alt="Cart logo" />

            <span><b> {{planAmount}}</b></span>
          </div> -->

            <div class="col-6 mt-4">
              <span style="font-size: 14px;">{{lang?.Adding_Employee_for}} <b>{{companyName}}/{{companyId}}</b></span>
            </div>
            <div class="col-6 text-end d-flex justify-content-end px-3"
              *ngIf="employeeDealingPlansarr.length>0 || payrollCCplansarr.length>0 || iafgplansCheck.length>0">
              <span> <img class="cartlogo" src="../../../assets/img/cart.png" alt="Cart logo" /></span>
              <span class="text-start" style="margin-top: 15px;">
                <!-- ./../../assets/img/cart.png -->

                <!-- <div><b>{{empDirectpayPlangrandTotal | number: "1.2-2"}}</b></div> -->
                <div><b>{{effectiveEmployeeTotalContibution | number: "1.2-2"}}</b></div>
                <!-- <div><b>{{effectiveEmployeeTotalContibution | number: "1.2-2"}}</b></div> -->
                <div>{{lang?.Monthly_premium}}</div>
                <div>{{lang?.Taxes_included}}</div>
              </span>
            </div>

          </div>
          <div class="row tabs">
            <div class="col-12 d-flex justify-content-evenly">
              <div class="tab w-100 justify-content-between" [ngClass]="{ active: selectedTab === 'tab1' }"
                (click)="selectTab('tab1')">
                {{lang?.Personal_Info}}
                <img style="display: none;" src="./../../assets/img/logo/blue_checkmark.png" alt="" id=""
                  class="checkmark-width imgdisplay1">

              </div>
              <div class="tab w-100" *ngIf="customerPlansInActive!=true"
                [ngClass]="{ active: selectedTab === 'tab2', isNotActive:(selectedTab==='tab1')}"
                (click)="selectTab('tab2')">
                {{lang?.Plan_Selection}}

                <!-- <img [ngClass]="{ activeTab1Img: selectedTab === 'tab2', isNotActive:(selectedTab==='tab1')}" src="./../../assets/img/logo/checkmark.png" alt=""  id="" class="checkmark-width"> -->
                <img style="display: none;" src="./../../assets/img/logo/blue_checkmark.png" alt="" id=""
                  class="checkmark-width imgdisplay2">

              </div>
              <div class="tab w-100"
                [ngClass]="{ active: selectedTab === 'tab3', isNotActive:(selectedTab==='tab1'||selectedTab==='tab2')}"
                (click)="selectTab('tab3')">
                {{lang?.Enrollment_Summary}}

                <!-- <img [ngClass]="{ activeTab1Img: selectedTab === 'tab3', isNotActive:(selectedTab==='tab1')}" src="./../../assets/img/logo/checkmark.png" alt=""  id="" class="checkmark-width"> -->
                <img style="display: none;" src="./../../assets/img/logo/blue_checkmark.png" alt="" id=""
                  class="checkmark-width imgdisplay3">
              </div>
            </div>

            <!-- <div class="col-3 bordertopColour">
            <div class="tab" [ngClass]="{ active: selectedTab === 'tab4' }" (click)="selectTab('tab4')">

            </div>
          </div> -->
          </div>
        </div>


        <div class="tab-content alltabs">
          <div *ngIf="selectedTab === 'tab1'">
            <form [formGroup]="userForm" #myForm="ngForm">

              <!-- Employee Information start ************************** -->

              <div class="form-container linescrollbar p-2">
                <div class="row">
                  <div class="form-group col-12">
                    <b id="header-font">{{lang?.Employee_Information}}</b>
                    <hr class="employeeInfoHrLine hrLineMargins">
                  </div>
                </div>


                <div class="row" *ngIf="false">
                  <div class="form-group col 12 col-md-4">
                    <label for="memberType">{{lang?.Member_Type}}<span class="text-danger">*</span></label>
                    <select class="form-select border border-dark" name="memberType" id="memberType"
                      formControlName="memberType" (change)="memberTypeChange($event)">
                      <option value="null" selected>{{lang?.Select}}</option>
                      <option value="GIG">{{lang?.GIG}}</option>
                      <option value="STUDENT">{{lang?.Student}}</option>

                      <!-- <option value="CORP">Corp</option> -->
                    </select>
                    <div class="help-block text-danger" *ngIf="(userForm.get('memberType')?.touched &&
                                    userForm.get('memberType')?.hasError('required'))||
                                    (userForm.get('memberType')?.hasError('required') && myForm.submitted)">
                      {{lang?.Please_select_member_type}}
                    </div>
                  </div>
                  <div class="form-group col 12 col-md-4" *ngIf="showBrokersList">
                    <label for="broker">
                      {{lang?.Broker}}<span class="text-danger">*</span>
                    </label>
                    <select class="form-select border border-dark" formControlName="brokername" name="broker"
                      id="broker" (change)="getForms($event.target.value)">
                      <option value="null">{{lang?.Select}}</option>
                      <option *ngFor="let broker of brokers" [value]="broker.id">{{broker.name}}</option>
                    </select>
                    <div class="help-block text-danger" *ngIf="(userForm.get('brokername')?.touched &&
                                  userForm.get('brokername')?.hasError('required'))||
                                  (userForm.get('brokername')?.hasError('required') && myForm.submitted)">
                      {{lang?.Please_select_broker_name}}
                    </div>
                  </div>
                  <div class="form-group col 12 col-md-4" *ngIf="showForm">
                    <label for="form">Form<span class="text-danger">*</span></label>
                    <select class="form-select border border-dark" formControlName="formrname" name="broker" id="form">
                      <option value="null">{{lang?.Select}}</option> <!-- {{form?.name}}- -->
                      <option *ngFor="let form of forms[0]?.signupForms" [value]="form.id">
                        {{form?.formType}}-{{form?.link}}</option>
                    </select>
                    <div class="help-block text-danger" *ngIf="(userForm.get('brokername')?.touched &&
                                    userForm.get('formrname')?.hasError('required'))||
                                    (userForm.get('formrname')?.hasError('required') && myForm.submitted)">
                      {{lang?.Please_select_broker_name}}
                    </div>
                  </div>

                </div>
                <div class="row">

                  <div class="form-group col 12 col-md-4" *ngIf="role=='ADMINISTRATOR'">
                    <label for="fusbill">{{lang?.IGBMS_Id}}</label>
                    <!-- <input type="text" class="form control checking-field border border-dark" > -->
                    <input type="text" class="form-control checking-field border border-dark" id="fusbillId"
                      placeholder="{{lang?.IGBMS_Id}}" formControlName="fusbillId" (keypress)="numberOnly($event)" />
                  </div>
                  <div class="form-group col 12 col-md-3 pt-4" *ngIf="role=='ADMINISTRATOR'">
                    <!-- <button class="checkButton"  (click)="checkFusBillId()">Check</button> -->
                  </div>
                  <div class="form-group col-md-6" *ngIf="employercheck">
                    <label for="firstname">


                      {{lang?.Employer_Name}}<span style="color: red">*</span></label>
                    <!-- [ngModel] =applicantPlanEnrollmentDate -->
                    <input type="text" class="form-control border border-dark text-capitalize" id="employername"
                      placeholder="{{lang?.Employer_Name}}" (keypress)="alphabatesOnly($event)"
                      formControlName="employername" [ngModel]="employername" maxlength="40" minlength="1" />
                    <div class="help-block text-danger" *ngIf="(userForm.get('employername')?.touched &&
                                      userForm.get('employername')?.hasError('required')) ||
                                    (userForm.get('employername')?.hasError('required') && myForm.submitted)">
                      {{lang?.Please_enter_Employer_Name}}
                    </div>
                    <div class="help-block text-danger" *ngIf="userForm.get('employername')?.hasError('minlength')">
                      <!-- {{ lang?.First_Name_minimum_of_2_Characters_and_without_numbers }} -->
                      Employer Name minimum of 1 Characters and without numbers
                    </div>
                  </div>
                </div>
                <div class="row">

                  <div class="form-group col-12 col-md-6">
                    <label id="label">{{ lang?.Plan_Enrollment_Date }}<span class="text-danger">*</span></label>
                    <select class="form-select border border-dark" id="planenrollmentdate" placeholder="Select"
                      formControlName="planEnrollmentDate">
                      <option value="null" label="" selected disabled>{{ lang?.Select }}</option>
                      <option *ngFor="let name of configPlanEnrollmentDate" [value]="name" [label]="name">
                        {{ name }}
                      </option>
                    </select>


                    <div class="help-block text-danger" *ngIf="(userForm.get('planEnrollmentDate')?.touched &&
                                  userForm.get('planEnrollmentDate')?.hasError('required')) ||
                                  (userForm.get('planEnrollmentDate')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_choose_plan_enrollment_date }}
                    </div>



                  </div>
                  <div class="form-group col-12 col-md-6" *ngIf="displayStudentId">
                    <label id="label">{{lang?.Student_Id}}<span class="text-danger">*</span></label>
                    <input type="text" class="form-control checking-field border border-dark" id="studentId"
                      onkeydown="return /[A-Za-z0-9-]/i.test(event.key)" placeholder="{{lang?.Student_Id}}"
                      formControlName="studentId" (input)="changeTextToUppercase('studentId')" />
                    <div class="help-block text-danger" *ngIf="(userForm.get('studentId')?.touched &&
                                  userForm.get('studentId')?.hasError('required')) ||
                                  (userForm.get('studentId')?.hasError('required') && myForm.submitted)">
                      {{lang?.Please_enter_student_id}}
                      <!-- {{ lang1.Please_enter_studentId }}  -->
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12 col-md-6  ">
                    <label id="label">{{ lang?.First_Name }}<span class="text-danger">*</span></label>
                    <input type="text" class="form-control border border-dark text-capitalize" id="givenname"
                      (keypress)="alphabatesOnly($event)" [(ngModel)]="firstName"
                      placeholder="{{ lang?.First_Name_as_shown_on_Provincial_Health_Card_UHIP_Card }}"
                      formControlName="givenname" maxlength="40" minlength="1" />

                    <div class="help-block text-danger" *ngIf="(userForm.get('givenname')?.touched &&
                                userForm.get('givenname')?.hasError('required')) ||
                              (userForm.get('givenname')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_enter_first_name }}

                    </div>
                    <div class="help-block text-danger" *ngIf="userForm.get('givenname')?.hasError('minlength')">
                      {{ lang?.First_Name_minimum_of_1_Character_and_without_numbers }}
                    </div>
                    <div class="help-block text-danger" *ngIf="userForm.get('givenname')?.hasError('pattern')">
                      {{shouldtallownumberandspecialcharacters}}
                    </div>

                  </div>
                  <div class="form-group col-12 col-md-6  ">
                    <label id="label" for="lastname">{{ lang?.Last_Name }}<span class="text-danger">*</span></label>
                    <input type="text" class="form-control checking-field border border-dark text-capitalize"
                      id="lastname" placeholder="{{ lang?.Last_Name_as_shown_on_Provincial_Health_Card_UHIP_Card }}"
                      [(ngModel)]="lastName" (keypress)="alphabatesOnly($event)" formControlName="lastname"
                      maxlength="40" minlength="1" />

                    <div class="help-block text-danger" *ngIf="(userForm.get('lastname')?.touched &&
                                  userForm.get('lastname')?.hasError('required')) ||
                                (userForm.get('lastname')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_enter_last_name }}

                    </div>
                    <div class="help-block text-danger" *ngIf="userForm.get('lastname')?.hasError('minlength')">
                      {{ lang?.Last_Name_minimum_of_1_Character_and_without_numbers }}
                    </div>
                    <div class="help-block text-danger" *ngIf="userForm.get('lastname')?.hasError('pattern')">
                      {{shouldtallownumberandspecialcharacters}}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12 col-md-6  ">
                    <label id="label">{{ lang?.Email }}<span class="text-danger">*</span></label>
                    <input type="email" class="form-control checking-field border border-dark" id="email"
                      placeholder="{{ lang?.Email }}" formControlName="email" [(ngModel)]="primaryEmail"
                      (input)="TextToLowerCase(userForm,'email')" />

                    <div class="help-block text-danger" *ngIf="(userForm.get('email')?.touched &&
                                   userForm.get('email')?.hasError('required')) ||
                                   (userForm.get('email')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_enter_email_Id }}

                    </div>
                    <!-- <div class="help-block text-danger" *ngIf="userForm.get('email')?.hasError('invalidEmail')">
                                      {{ lang?.Please_enter_valid_email }}
                                    </div> -->
                    <div class="help-block text-danger" *ngIf="userForm.get('email')?.hasError('pattern')">
                      {{ lang?.Please_enter_valid_email }}
                    </div>
                    <!-- <div class="help-block text-danger" *ngIf="(userForm.get('email')?.touched &&
                                      userForm.get('email')?.hasError('pattern')) ||
                                    (userForm.get('email')?.hasError('pattern') && myForm.submitted)">
                                  {{ lang?.Please_enter_valid_email }}
                                    </div>  -->

                  </div>
                  <div class="form-group col-12 col-md-6  ">
                    <label id="label">{{ lang?.Phone_Number }}<span class="text-danger">*</span></label>
                    <input type="text" class="form-control border border-dark" id="phonenumber"
                      placeholder="{{ lang?.Phone_Number }}" (change)="phoneFormat($event)"
                      formControlName="phonenumber" (keypress)="numberOnly($event)" maxlength="20"
                      [(ngModel)]="primaryPhone" />

                    <div class="help-block text-danger" *ngIf="(userForm.get('phonenumber')?.touched &&
                                  userForm.get('phonenumber')?.hasError('required')) ||
                                  (userForm.get('phonenumber')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_enter_Phone_Number }}

                    </div>
                    <div class="help-block text-danger" *ngIf="userForm.get('phonenumber')?.hasError('minlength')">
                      {{ lang?.Phone_number_is_minimum_of_10_digits }}
                    </div>
                    <div class="help-block text-danger" *ngIf="userForm.get('phonenumber')?.hasError('maxlength')">
                      {{ lang?.Phone_number_is_maximum_of_10_digits }}
                    </div>
                    <div class="help-block text-danger" *ngIf="userForm.get('phonenumber')?.hasError('pattern')">
                      {{lang?.Invalid_phone_number_format}}
                    </div>

                  </div>
                </div>
                <div class="row  ">
                  <div class="form-group col-12 col-md-4  ">
                    <label id="label" for="dateofbirth">{{ lang?.Date_of_Birth
                      }}<span class="text-danger">*</span></label>

                    <!-- <input type="text" placeholder="MM-DD-YYYY" [(ngModel)]="applicantDateofBirth"
                                      class="form-control checking-field border border-dark" formControlName="dateofbirth" bsDatepicker
                                      [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }" />  (change)="setDateOfHire()"-->
                    <input type="text" class="form-control border border-dark" id="childInfoDOB"
                      placeholder="MM-DD-YYYY" formControlName="dateofbirth" [minDate]="minDate" [maxDate]="maxDate" #dp
                      value="{{dateofbirth | date:'MM-dd-yyyy'}} " bsDatepicker [(bsValue)]="myDateOfBirth"
                      [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" [(ngModel)]="dateofbirth">

                    <div class=" help-block text-danger"
                      *ngIf="(userForm.get('dateofbirth')?.touched &&
                                                userForm.get('dateofbirth')?.hasError('required')) ||
                                                (userForm.get('dateofbirth')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_Choose_Date_of_Birth }}
                    </div>
                    <div class="help-block text-danger" *ngIf="userForm.get('dateofbirth')?.hasError('mindateofbirth')">
                      {{ lang?.Registrant_age_must_be_16_or_greater }}
                    </div>
                    <div class="help-block text-danger" *ngIf="userForm.get('dateofbirth')?.hasError('maxdateofbirth')">
                      {{ lang?.Registrant_age_must_be_60_or_below }}
                    </div>

                  </div>
                  <div class="form-group col-12 col-md-4  ">
                    <label id="label" for="gender">{{ lang?.Gender }}<span class="text-danger">*</span></label>
                    <select class="form-select border border-dark" id="gender" placeholder="Select"
                      formControlName="gender">
                      <option value="null">{{ lang?.Select }}</option>
                      <option value="Male">{{ lang?.Male }}</option>
                      <option value="Female">{{ lang?.Female }}</option>
                      <option value="Non-Binary">{{ lang?.Non_Binary }}</option>
                      <option value="Undisclosed">{{ lang?.Undisclosed }}</option>
                    </select>


                    <div class="help-block text-danger" *ngIf="(userForm.get('gender')?.touched &&
                                                userForm.get('gender')?.hasError('required')) ||
                                                (userForm.get('gender')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_select_gender }}
                    </div>

                  </div>
                  <div class="form-group col-12 col-md-4  ">
                    <label id="label" for="dateofbirth">{{ lang?.Date_of_Hire
                      }}<span class="text-danger">*</span></label>

                    <!-- <input type="text" placeholder="MM-DD-YYYY" [(ngModel)]="applicantDateofBirth"
                                      class="form-control checking-field border border-dark" formControlName="dateofbirth" bsDatepicker
                                      [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }" /> -->
                    <input type="text" class="form-control border border-dark" id="childInfoDOB"
                      placeholder="MM-DD-YYYY" formControlName="dateofhire" [minDate]="" bsDatepicker #dp
                      [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"
                      value="{{dateofhire | date:'MM-dd-yyyy'}}" [(bsValue)]="myDateOfHire" [(ngModel)]="dateofhire">

                    <div class=" help-block text-danger"
                      *ngIf="(userForm.get('dateofhire')?.touched &&
                                                userForm.get('dateofhire')?.hasError('required')) ||
                                                (userForm.get('dateofhire')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_choose_date_of_hire }}
                    </div>


                  </div>
                </div>


                <!-- **************************************************************************************** -->
                <!-- Home Mailing Address start -->

                <div class="row">
                  <div class="form-group col-12  ">
                    <b id="header-font">{{ lang?.Home_Mailing_Address }}</b>
                    <hr class="homeMailingAddressHrLine hrLineMargins">
                  </div>
                </div>
                <!--  (keypress)="alphabatesOnly($event)" -->
                <div class="row  ">
                  <div class="form-group col-12 col-md-4">
                    <label>{{lang?.Street_Address }}<span class="text-danger">*</span></label>
                    <input type="text" class="form-control checking-field border border-dark text-capitalize"
                      id="streetaddress" placeholder="{{ lang?.Street_Address }}" formControlName="streetaddress"
                      [(ngModel)]="line1" />

                    <div class="help-block text-danger" *ngIf="(userForm.get('streetaddress')?.touched &&
                                  userForm.get('streetaddress')?.hasError('required')) ||
                                (userForm.get('streetaddress')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_enter_Street_Address }}
                    </div>

                    <div class="help-block text-danger" *ngIf="(userForm.get('streetaddress')?.touched &&
                                      userForm.get('streetaddress')?.hasError('pattern')) ||
                                    (userForm.get('streetaddress')?.hasError('pattern') && myForm.submitted)">
                      {{shouldtallownumberandspecialcharacters}}
                    </div>
                  </div>

                  <div class="form-group col-12 col-md-4  ">
                    <label id="label">{{ lang?.Street_Address_Line_2 }}<span></span></label>
                    <input type="text" class="form-control border border-dark text-capitalize" id="streetaddressline2"
                      placeholder="{{ lang?.Street_Address_Line_2 }}" formControlName="streetaddressline2"
                      [(ngModel)]="line2" />


                    <!-- <div class="help-block text-danger" *ngIf="(userForm.get('streetaddressline2')?.touched &&
                                                    userForm.get('streetaddressline2')?.hasError('required')) ||
                                                  (userForm.get('streetaddressline2')?.hasError('required') && myForm.submitted)">
                                      {{ lang?.Please_enter_Street_Address }}
                                    </div> -->

                    <div class="help-block text-danger"
                      *ngIf="(userForm.get('streetaddressline2')?.touched &&
                                                        userForm.get('streetaddressline2')?.hasError('pattern')) ||
                                                      (userForm.get('streetaddressline2')?.hasError('pattern') && myForm.submitted)">
                      {{shouldtallownumberandspecialcharacters}}
                    </div>
                  </div>

                  <div class="form-group col-12 col-md-4  ">
                    <label id="label" id="suiteNumber">{{ lang?.Unit_Apt_Suite }}<span></span></label>
                    <input type="text" class="form-control border border-dark text-capitalize" id="apt_suite"
                      placeholder="{{ lang?.Unit_Apt_Suite }}" formControlName="apt_suite" maxlength="50" />

                    <!-- <div class="help-block text-danger"
                                      *ngIf="userForm.get('apt_suite')?.touched && userForm.get('apt_suite')?.hasError('aptexpression')">
                                      {{lang1.enter_valid_apt}}
                                    </div> -->

                    <!-- <div class="help-block text-danger" *ngIf="
                                      userFormControl['apt_suite'].touched &&
                                      userFormControl['apt_suite'].invalid
                                    ">
                                      <div *ngIf="
                                        userFormControl['apt_suite'].errors &&
                                        userFormControl['apt_suite'].errors['aptexpression']
                                      ">
                                        {{lang1.enter_valid_apt}}
                                      </div>
                                    </div> -->
                  </div>
                </div>

                <div class="row  ">
                  <div class="form-group col-12 col-md-3">
                    <label id="label">{{ lang?.City }}<span class="text-danger">*</span></label>
                    <input type="text" class="form-control checking-field border border-dark text-capitalize" id="city"
                      placeholder="{{ lang?.City }}" formControlName="city" [(ngModel)]="city" />
                    <!-- <div class="help-block text-danger" *ngIf="
                                      userFormControl['city'].touched &&
                                      userFormControl['city'].invalid
                                    ">
                                    <div *ngIf="
                                        userFormControl['city'].errors &&
                                        userFormControl['city'].errors['required']
                                      ">
                                      {{ lang?.Please_enter_City }}
                                    </div>
                                  </div> -->

                    <div class="help-block text-danger" *ngIf="(userForm.get('city')?.touched &&
                                  userForm.get('city')?.hasError('required')) ||
                                (userForm.get('city')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_enter_City }}
                    </div>

                    <div class="help-block text-danger" *ngIf="(userForm.get('city')?.touched &&
                                    userForm.get('city')?.hasError('pattern')) ||
                                  (userForm.get('city')?.hasError('pattern') && myForm.submitted)">
                      {{shouldtallownumberandspecialcharacters}}
                    </div>
                  </div>

                  <div class="form-group col-12 col-md-3">
                    <label id="label" for="Province">{{lang?.Province_of_Residence}}<span
                        class="text-danger">*</span></label>
                    <select class="form-select border border-dark ProvinceClass" id="Province" placeholder="Select"
                      formControlName="province" (change)="provincelist12345($event)" [(ngModel)]="state">
                      <option value="null" selected>{{ lang?.Select }}</option>
                      <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                        {{ name.shortName }}
                      </option>
                    </select>

                    <div class="help-block text-danger" *ngIf="(userForm.get('province')?.touched &&
                                  userForm.get('province')?.hasError('required')) ||
                                (userForm.get('province')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_select_Province }}
                    </div>

                  </div>
                  <!-- changeTextToUppercase -->
                  <div class="form-group col-12 col-md-3">
                    <label id="label">{{ lang?.Postal_Code }}<span class="text-danger">*</span></label>

                    <input type="text" class="form-control checking-field border border-dark" id="postalcode"
                      placeholder="{{ lang?.Postal_Code }}" formControlName="postalcode"
                      (input)="changeTextToUppercasePostalCode('postalcode', $event)" [(ngModel)]="postalZip" />

                    <div class="help-block text-danger" *ngIf="(userForm.get('postalcode')?.touched &&
                                            userForm.get('postalcode')?.hasError('required')) ||
                                          (userForm.get('postalcode')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_enter_postal_code }}
                    </div>

                    <div class="help-block text-danger" *ngIf="
                                      (userForm.get('postalcode')?.touched &&
                                        userForm
                                          .get('postalcode')
                                          ?.hasError('invalidPostalCode')) ||
                                      (invalidpostalcodeprivince &&
                                        !userForm.get('province')?.hasError('required'))
                                    ">{{ lang?.Please_enter_valid_postal_code }}</div>
                  </div>
                  <div class="form-group col-12 col-md-3">
                    <label id="label" for="Province">{{lang?.Province_of_Employment}}<span
                        class="text-danger">*</span></label>
                    <select class="form-select border border-dark ProvinceClass" id="Province" placeholder="Select"
                      formControlName="workingProvince" (change)="workingProvincelist($event)">
                      <option value="null" selected>{{ lang?.Select }}</option>
                      <option *ngFor="let name of working_provinces" [value]="name.shortName">
                        {{ name.shortName }}
                      </option>
                    </select>

                    <div class="help-block text-danger" *ngIf="(userForm.get('province')?.touched &&
                                  userForm.get('workingProvince')?.hasError('required')) ||
                                (userForm.get('workingProvince')?.hasError('required') && myForm.submitted)">
                      {{ lang?.Please_select_Province }}
                    </div>

                  </div>
                </div>


                <!-- Are you an International student started -->

                <div class="row">
                  <div class="form-group col-12 col-md-6 " id="box">
                    <div class="col-12 ps-0">
                      <label
                        for="">{{lang?.I_confirm_that_I_am_actively_working_20_or_more_hours_per_week_to_meet_plan_eligibility}}<span
                          class="text-danger">*</span></label>
                    </div>
                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="workinghours"
                        id="workinghoursYes" value="true" formControlName="workinghours"
                        (change)="workinghours($event.target.value)" />
                      <label class="form-check-label" for="workinghoursYes">{{
                        lang?.Yes
                        }}</label>
                    </div>
                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="workinghours"
                        id="workinghoursNo" value="false" formControlName="workinghours"
                        (change)="workinghours($event.target.value)" />
                      <!-- (mouseover)="provincialhealthpopup() -->
                      <label class="form-check-label" for="workinghoursNo">{{
                        lang?.No
                        }}</label>
                    </div>
                    <div class="help-block text-danger"
                      *ngIf="(userForm.get('workinghours')?.touched &&
                                    userForm.get('workinghours')?.hasError('required')) ||
                                  (userForm.get('workinghours')?.hasError('required') && myForm.submitted)||(userForm.get('workinghours').value=='false')">
                      {{lang?.To_enroll_in_the_plan_you_need_to_be_working_20_or_more_hours_per_week}}
                    </div>
                    <!-- <div class="help-block text-danger" *ngIf="(userForm.get('workinghours')?.touched &&
                                    userForm.get('workinghours')?.hasError('required')) ||
                                  (userForm.get('workinghours')?.hasError('required') && myForm.submitted)">
                                  To enroll in the plan you need to be working 20 or more hours per week
                                    </div> -->
                  </div>
                  <div class="form-group col-12 col-md-6 ps-0" id="box" *ngIf="hourperweekvalue">
                    <div class="col-12 ps-3">
                      <label for="">{{lang?.How_many_hours_per_week_do_you_work}}<span
                          class="text-danger">*</span></label>
                    </div>

                    <div class="form-check form-check-inline col-6">
                      <input class="form-control checking-field border border-dark" type="number" id="hoursperweek"
                        formControlName="hoursperweek" maxlength="2" min="20" max="80"
                        (change)="hoursperweekvalue($event)" />
                    </div>




                    <div class="help-block text-danger ps-3" *ngIf="(userForm.get('hoursperweek')?.touched &&
                                  userForm.get('hoursperweek')?.hasError('required')) ||
                                  (userForm.get('hoursperweek')?.hasError('required') && myForm.submitted)">
                      {{lang?.Please_select_working_hours_per_week}}
                    </div>
                    <div class="help-block text-danger ps-3" *ngIf="userForm.get('hoursperweek').touched &&
                                      userForm.get('hoursperweek').hasError('mininvalidhours')">
                      {{lang?.Hours_Per_week_should_be_more_than_20}}</div>
                    <div class="help-block text-danger ps-3" *ngIf="
                                      userForm.get('hoursperweek').touched &&
                                      userForm.get('hoursperweek').hasError('maxinvalidhours')">
                      {{lang?.Hours_Per_week_should_be_less_than_80}}</div>

                  </div>
                  <div class="form-group col-12 col-md-6" id="box" *ngIf="checkstudenthealthcardstatus_UHIP">
                    <div class="col-12">
                      <label for=""> {{ lang?.Provincial_Health_Coverage }}<span class="text-danger">*</span></label>
                    </div>

                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="provincialhealth"
                        id="provincialhealthyes" value="true" formControlName="provincialhealth"
                        (change)="provincialhealth($event)" />
                      <label class="form-check-label" for="provincialhealthyes">{{
                        lang?.Yes
                        }}</label>
                    </div>
                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="provincialhealth"
                        id="provincialhealthno" value="false" formControlName="provincialhealth"
                        (change)="provincialhealth($event)" />
                      <!-- (mouseover)="provincialhealthpopup() -->
                      <label class="form-check-label" for="provincialhealthno">{{
                        lang?.No
                        }}</label>
                    </div>
                    <div class="help-block text-danger"
                      *ngIf="(userForm.get('provincialhealth')?.touched &&
                                  userForm.get('provincialhealth')?.hasError('required'))||
                                  (userForm.get('provincialhealth')?.hasError('required')&& myForm.submitted) || checkhealthcardstatus">
                      {{ lang?.You_are_not_eligible_to_apply_without_a_health_card_from_your_province }}
                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6 grpinfo-right" id="box">
                    <div class="lineheight">
                      {{lang?.I_confirm_that_I_have_provincial_health_coverage_in_my_province_of_residence }}
                    </div>

                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="provincialhealth"
                        id="provincialhealthyes" value="true" formControlName="provincialhealth"
                        (change)="provincialhealth($event)" />
                      <label class="form-check-label" for="provincialhealthyes">{{lang?.Yes }}</label>
                    </div>
                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="provincialhealth"
                        id="provincialhealthno" value="false" formControlName="provincialhealth"
                        (change)="provincialhealth($event)" />

                      <label class="form-check-label" for="provincialhealthno">{{lang?.No}}</label>
                    </div>
                    <div class="clearfix"></div>
                    <span class="help-block text-danger" *ngIf="
                                        (userForm.get('provincialhealth').touched &&
                                          userForm
                                            .get('provincialhealth')
                                            .hasError('required')) ||
                                        checkhealthcardstatus ||
                                        (userForm.get('provincialhealth').hasError('required') &&
                                          myForm.submitted)
                                      "> {{lang?.You_are_not_eligible_to_apply_without_a_health_card_from_your_province
                      }}</span>

                  </div>
                </div>
                <div class="row" *ngIf="showExtrafeilds">
                  <div class="form-group col-md-6 mt-2">
                    <label>{{lang?.Date_of_Arrival_in_Canada}}<span style="color: red">*</span></label>


                    <input type="text" class="form-control" formControlName="dateOfArrival" *ngIf="true" #dp
                      placeholder="MM-DD-YYYY" value="{{ dateOfArrival | date: 'MM-dd-yyyy'}}" bsDatepicker
                      [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" [(bsValue)]="myDateValue1"
                      [(ngModel)]="dateOfArrival" />
                    <span class="help-block text-danger" *ngIf="
                                            (userForm.get('dateOfArrival').touched &&
                                              userForm.get('dateOfArrival').hasError('required')) ||
                                            (userForm.get('dateOfArrival').hasError('required') &&
                                              myForm.submitted)
                                          ">{{lang?.Please_select_date_of_arrival_in_Canada}}</span>
                  </div>
                  <div class="form-group col-md-6 mt-2">
                    <div>
                      <label>{{lang?.Country_of_Origin}}<span style="color: red">*</span></label>
                    </div>


                    <select class="form-control" id="countryOrigin" placeholder="Select"
                      formControlName="countryOrigin">
                      <option value="" label="">{{lang?.Select}}</option>
                      <option *ngFor="let country of countries" [value]="country">{{country}}</option>
                    </select>
                    <div class="clearfix"></div>
                    <span class="help-block text-danger" *ngIf="
                                        (userForm.get('countryOrigin').touched &&
                                          userForm.get('countryOrigin').hasError('required')) ||
                                        (userForm.get('countryOrigin').hasError('required') &&
                                          myForm.submitted)
                                      ">{{lang?.Please_select_country_of_origin}}</span>
                  </div>
                  <div class="form-group col-md-6 mt-2">
                    <div>
                      <label>{{lang?.Is_the_employee_a_landed_immigrant}}<span style="color: red">*</span></label>
                    </div>

                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="isEmployeeImigrant"
                        id="isEmployeeImigrantyes" value="true" formControlName="isEmployeeImigrant"
                        (change)="landedimmigrantStatus($event)" />
                      <label class="form-check-label" for="isEmployeeImigrantyes">{{lang?.Yes }}</label>
                    </div>
                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="isEmployeeImigrant"
                        id="isEmployeeImigrantno" value="false" formControlName="isEmployeeImigrant"
                        (change)="landedimmigrantStatus($event)" />
                      <!-- (mouseover)="provincialhealthpopup() -->
                      <label class="form-check-label" for="isEmployeeImigrantno">{{lang?.No}}</label>
                    </div>
                    <div class="clearfix"></div>

                    <span class="help-block text-danger"
                      *ngIf="
                                                            (userForm.get('isEmployeeImigrant').touched &&
                                                              userForm.get('isEmployeeImigrant').hasError('required')) ||
                                                            (userForm.get('isEmployeeImigrant').hasError('required') &&
                                                              myForm.submitted)
                                                          ">{{lang?.Please_choose_employee_landed_immigrant_status}}</span>
                  </div>
                  <div class="form-group col-md-6 mt-2" *ngIf="showlandedimgratestatus">
                    <div>
                      <label>{{lang?.Will_he_she_be_applying_for_landed_status}}<span
                          style="color: red">*</span></label>
                    </div>

                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="applylandedstaus"
                        id="applylandedstausyes" value="true" formControlName="applylandedstaus" />
                      <label class="form-check-label" for="applylandedstausyes">{{lang?.Yes }}</label>
                    </div>
                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="applylandedstaus"
                        id="applylandedstausno" value="false" formControlName="applylandedstaus" />
                      <!-- (mouseover)="provincialhealthpopup() -->
                      <label class="form-check-label" for="applylandedstausno">{{lang?.No}}</label>

                    </div>
                    <div class="clearfix"></div>
                    <span class="help-block text-danger" *ngIf="
                                                            (userForm.get('applylandedstaus').touched &&
                                                              userForm.get('applylandedstaus').hasError('required')) ||
                                                            (userForm.get('applylandedstaus').hasError('required') &&
                                                              myForm.submitted)
                                                          ">{{lang?.Please_choose_landed_status}}</span>
                  </div>
                  <div class="form-group col-md-6 mt-2">
                    <div>
                      <label>{{lang?.Is_coverage_required_for_the_employee}}<span style="color: red">*</span></label>
                    </div>

                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="coverageRequiredOfEmployee"
                        id="coverageRequiredOfEmployeeyes" value="true" formControlName="coverageRequiredOfEmployee" />
                      <label class="form-check-label" for="coverageRequiredOfEmployeeyes">{{lang?.Yes }}</label>
                    </div>
                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="coverageRequiredOfEmployee"
                        id="coverageRequiredOfEmployeeno" value="false" formControlName="coverageRequiredOfEmployee" />
                      <label class="form-check-label" for="coverageRequiredOfEmployeeno">{{lang?.No}}</label>
                    </div>
                    <div class="clearfix"></div>
                    <span class="help-block text-danger" *ngIf="
                                          (userForm.get('coverageRequiredOfEmployee').touched &&
                                            userForm.get('coverageRequiredOfEmployee').hasError('required')) ||
                                          (userForm.get('coverageRequiredOfEmployee').hasError('required') &&
                                            myForm.submitted)
                                        ">{{lang?.Please_select_coverage_required_for_employee}}</span>
                  </div>


                </div>

                <!-- Spouse Information -->
                <div class="row">
                  <div class="form-group col-12  ">
                    <b id="header-font">{{ lang?.Spouse_Information }}</b>
                    <hr class="spouceInfoInfoHrLine hrLineMargins">
                  </div>
                  <div class="col-12">
                    <label for="form-label"> {{
                      lang?.Do_you_have_a_spouse_married_or_living_common_law_for_at_least_one_year }}<span
                        class="text-danger">*</span></label>
                  </div>

                  <div class="col-12 col-md-6">
                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="havingspouse"
                        id="havingspouseyes" value="true" formControlName="havingspouse"
                        (change)="spouseinfo($event)" />
                      <label class="form-check-label" for="havingspouseyes">{{ lang?.Yes }}</label>
                    </div>

                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="havingspouse"
                        id="havingspouseno" value="false" formControlName="havingspouse"
                        (change)="spouseinfo($event)" />
                      <label class="form-check-label" for="havingspouseno">{{ lang?.No}}</label>
                    </div>
                  </div>

                  <div class="help-block text-danger" *ngIf="
                                (userForm.get('havingspouse')?.touched &&
                                  userForm
                                    .get('havingspouse')
                                    ?.hasError('required')) ||
                                (userForm.get('havingspouse')?.invalid &&
                                  myForm.submitted)
                              ">
                    {{ lang?.Please_choose_spouse_status }}
                  </div>

                  <!-- spouce information if yes -->
                  <div *ngIf="spouseinformation">
                    <div class="row  ">
                      <div class="col-12 col-md-4">

                        <label for="spousefirstname">{{ lang?.First_Name
                          }}<span class="text-danger">*</span></label>
                        <input type="text" class="form-control checking-field border border-dark text-capitalize"
                          id="spousefirstname" (keypress)="alphabatesOnly($event)" placeholder="{{
                                          lang?.Name_as_shown_on_Provincial_Health_Card
                                        }}" formControlName="spousefirstname" />

                        <div class="help-block text-danger"
                          *ngIf="(userForm.get('spousefirstname')?.touched && userForm.get('spousefirstname')?.hasError('required'))
                                        || (userForm.get('spousefirstname')?.hasError('required') && myForm.submitted)">
                          {{ lang?.Please_enter_spouse_first_name }}
                        </div>

                        <div class="help-block text-danger"
                          *ngIf="(userForm.get('spousefirstname')?.touched && userForm.get('spousefirstname')?.hasError('minlength'))
                                        || (userForm.get('spousefirstname')?.hasError('minlength') && myForm.submitted)">
                          {{lang?.First_Name_minimum_of_1_Character_and_without_numbers}}
                        </div>

                        <div class="help-block text-danger" *ngIf="(userForm.get('spousefirstname')?.touched && userForm.get('spousefirstname')?.hasError('pattern'))
                                        || (userForm.get('spousefirstname')?.hasError('pattern') && myForm.submitted)">
                          {{shouldtallownumberandspecialcharacters}}
                        </div>

                        <!-- <div class="help-block text-danger" *ngIf="
                                          userFormControl['spousefirstname'].touched &&
                                          userFormControl['spousefirstname'].invalid">
                                          <div *ngIf="
                                            userFormControl['spousefirstname'].errors &&
                                            userFormControl['spousefirstname'].errors['required']
                                          ">
                                            {{ lang1.please_enter_spouse_first_name }}
                                          </div>
                                        </div> -->
                      </div>
                      <div class="col-12 col-md-4">
                        <label for="spousefirstname">{{ lang?.Last_Name
                          }}<span class="text-danger">*</span></label>
                        <input type="text" class="form-control checking-field border border-dark text-capitalize"
                          id="spouselastname" (keypress)="alphabatesOnly($event)"
                          placeholder="{{ lang?.Name_as_shown_on_Provincial_Health_Card }}"
                          formControlName="spouselastname" />

                        <div class="help-block text-danger"
                          *ngIf="(userForm.get('spouselastname')?.touched
                                          && userForm.get('spouselastname')?.hasError('required'))
                                          || (userForm.get('spouselastname')?.hasError('required') && myForm.submitted)">
                          {{ lang?.Please_enter_spouse_last_name }}
                        </div>

                        <div class="help-block text-danger"
                          *ngIf="(userForm.get('spouselastname')?.touched
                                        && userForm.get('spouselastname')?.hasError('minlength'))
                                        || (userForm.get('spouselastname')?.hasError('minlength') && myForm.submitted)">
                          {{lang?.Last_Name_minimum_of_1_Character_and_without_numbers}}
                        </div>

                        <div class="help-block text-danger"
                          *ngIf="(userForm.get('spouselastname')?.touched
                                          && userForm.get('spouselastname')?.hasError('pattern'))
                                          || (userForm.get('spouselastname')?.hasError('pattern') && myForm.submitted)">
                          {{shouldtallownumberandspecialcharacters}}
                        </div>

                        <!-- <div class="help-block text-danger" *ngIf="
                                          userFormControl['spouselastname'].touched &&
                                          userFormControl['spouselastname'].invalid
                                        ">
                                          <div *ngIf="
                                            userFormControl['spouselastname'].errors &&
                                            userFormControl['spouselastname'].errors['required']
                                          ">
                                            {{ lang1.please_enter_spouse_last_name }}
                                          </div>
                                        </div> -->
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label for="">{{ lang?.Gender }}<span class="text-danger">*</span></label>
                        <select class="form-control border border-dark" formControlName="spousegender"
                          placeholder="Select">
                          <option value="" [selected]="!userForm.get('spousegender')?.value">{{ lang?.Select }}</option>
                          <option value="Male">{{ lang?.Male }}</option>
                          <option value="Female">{{ lang?.Female }}</option>
                          <option value="Non-Binary">{{ lang?.Non_Binary }}</option>
                          <option value="Undisclosed"> {{ lang?.Undisclosed }} </option>
                        </select>
                        <div class="help-block text-danger" *ngIf="(userForm.get('spousegender')?.touched
                                        && userForm.get('spousegender')?.hasError('required'))
                                        || (userForm.get('spousegender')?.hasError('required') && myForm.submitted)">
                          {{ lang?.Please_select_gender }}
                        </div>

                      </div>
                    </div>
                    <div class="row  ">
                      <div class="col-12 col-md-4">

                        <label>{{ lang?.Date_of_Birth
                          }}<span class="text-danger">*</span></label>


                        <input type="text" class="form-control checking-field border border-dark"
                          placeholder="MM-DD-YYYY" formControlName="spousedateofbirth" bsDatepicker [minDate]="minDate"
                          #dp [maxDate]="maxDate" value="{{spousedateofbirth | date:'MM-dd-yyyy'}}"
                          [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"
                          [(bsValue)]="spouseDateOfBirth" [(ngModel)]="spousedateofbirth" />



                        <div class="help-block text-danger" *ngIf="(userForm.get('spousedateofbirth')?.touched &&
                                    userForm.get('spousedateofbirth')?.hasError('required')) ||
                                    (userForm.get('spousedateofbirth')?.hasError('required') && myForm.submitted)">
                          {{ lang?.Please_Choose_Date_of_Birth }}
                        </div>
                        <div class="help-block text-danger"
                          *ngIf="userForm.get('spousedateofbirth')?.hasError('mindateofbirth')">
                          {{ lang?.Registrant_age_must_be_16_or_greater }}
                        </div>
                        <div class="help-block text-danger"
                          *ngIf="userForm.get('spousedateofbirth')?.hasError('maxdateofbirth')">
                          {{ lang?.Registrant_age_must_be_60_or_below }}
                        </div>


                        <!-- <div class="help-block text-danger" *ngIf="
                                          userFormControl['spousedateofbirth'].touched &&
                                          userFormControl['spousedateofbirth'].invalid
                                        ">
                                          <div *ngIf="
                                            userFormControl['spousedateofbirth'].errors &&
                                            userFormControl['spousedateofbirth'].errors[
                                              'required'
                                            ]
                                          ">
                                            {{ lang?.Please_Choose_Date_of_Birth }}
                                          </div>
                                          <div *ngIf="
                                            userFormControl['spousedateofbirth'].errors &&
                                            userFormControl['spousedateofbirth'].errors[
                                              'mindateofbirth'
                                            ]
                                          ">
                                            {{ lang?.Registrant_age_must_be_16_or_greater }}
                                          </div>
                                          <div *ngIf="
                                            userFormControl['spousedateofbirth'].errors &&
                                            userFormControl['spousedateofbirth'].errors[
                                              'maxdateofbirth'
                                            ]
                                          ">
                                            {{ lang?.Registrant_age_must_be_60_or_below }}
                                          </div>
                                        </div> -->
                      </div>
                      <!-- Below email why it is written dont have idea -->
                      <div class="col-12 col-md-4">
                        <div *ngIf="requireSpouseEmail">
                          <label>{{ lang?.Email
                            }}<span class="text-danger">*</span></label>
                          <input type="email" class="form-control checking-field border border-dark" id="email"
                            placeholder="{{ lang?.Email }}" formControlName="spouseemail"
                            (input)="TextToLowerCase(userFormControl,'spouseemail')" />
                          <div class="help-block text-danger" *ngIf="
                                            userFormControl['spouseemail'].touched &&
                                            userFormControl['spouseemail'].invalid
                                          ">
                            <div *ngIf="
                                              userFormControl['spouseemail'].errors &&
                                              userFormControl['spouseemail'].errors['required']
                                            ">
                              {{ lang?.Please_enter_email_Id }}
                            </div>
                            <div *ngIf="
                                              userFormControl['spouseemail'].errors &&
                                              userFormControl['spouseemail'].errors[
                                                'invalidEmail'
                                              ]
                                            ">
                              {{ lang?.Please_enter_valid_email }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- ************************************************** -->
                    </div>
                    <!-- Is your spouse covered by another Health and/or Dental insurance plan through their employer? -->
                    <div *ngIf="requireDentalHealthCoverage" class=" ">
                      <div *ngIf="spouseinformation">
                        <div class="row pt-2 ">
                          <label for="" class="form-label"> {{
                            lang?.Is_your_spouse_covered_by_another_Health_and_or_Dental_insurance_plan_through_their_employer
                            }} <span class="text-danger">*</span></label>
                          <div class="form-group col-12 col-md-6">
                            <div class="form-check form-check-inline col-3">
                              <input class="form-check-input border border-dark" type="radio" id="spousehealthcardyes"
                                value="true" formControlName="spousehealthcard" (click)="spousehealthcard($event)" />
                              <label class="form-check-label" for="spousehealthcardyes">
                                {{ lang?.Yes }}</label>
                            </div>
                            <div class="form-check form-check-inline col-3">
                              <input class="form-check-input border border-dark" type="radio" id="spousehealthcardno"
                                value="false" formControlName="spousehealthcard" (click)="spousehealthcard($event)" />
                              <label class="form-check-label" for="spousehealthcardno">{{ lang?.No}}</label>
                            </div>
                            <!-- spouce errors -->

                            <div class="help-block text-danger"
                              *ngIf="(userForm.get('spousehealthcard')?.touched && userForm.get('spousehealthcard')?.hasError('required'))
                                        || (userForm.get('spousehealthcard')?.hasError('required') && myForm.submitted)">
                              {{ lang?.Please_choose_spouse_insurance_status }}
                            </div>

                            <!-- <div class="help-block text-danger" *ngIf="
                                            userFormControl['spousehealthcard'].touched &&
                                            userFormControl['spousehealthcard'].invalid
                                          ">
                                          <div *ngIf="
                                              userFormControl['spousehealthcard'].errors &&
                                              userFormControl['spousehealthcard'].errors[
                                                'required'
                                              ]
                                            ">
                                            {{ lang1.please_choose_spouse_insurance_status }}
                                          </div>
                                        </div> -->
                          </div>
                        </div>


                        <div class="row" *ngIf="spousehealthcardinfo">
                          <div class="col-12 col-md-4">
                            <label class="">{{ lang?.Name_Of_The_Carrier }}<span class="text-danger">*</span></label>
                            <input type="text" class="form-control checking-field border border-dark text-capitalize"
                              id="spousenameofthecarrier" placeholder="{{ lang?.Name_Of_The_Carrier }}"
                              formControlName="Spousenameofthecarrier" />
                            <!-- (keypress)="alphabatesOnly($event)" -->
                            <div class="help-block text-danger"
                              *ngIf="(userForm.get('Spousenameofthecarrier')?.touched && userForm.get('Spousenameofthecarrier')?.hasError('required'))
                                        || (userForm.get('Spousenameofthecarrier')?.hasError('required') && myForm.submitted)">
                              {{ lang?.Please_enter_name_of_the_carrier }}
                            </div>

                            <!-- <div class="help-block text-danger" *ngIf="
                                          userFormControl['Spousenameofthecarrier'].touched &&
                                          userFormControl['Spousenameofthecarrier'].invalid">
                                          <div *ngIf="
                                            userFormControl['Spousenameofthecarrier'].errors &&
                                            userFormControl['Spousenameofthecarrier'].errors['required'] ">
                                            {{ lang?.Please_enter_name_of_the_carrier }}
                                          </div>
                                        </div> -->
                          </div>
                          <div class="col-12 col-md-4">
                            <label *ngIf="spousehealthcardinfo &&
                                          userFormControl['spousehealthcard'].value === 'true' ">{{
                              lang?.Coordination_of_Benefits_COB_Coverage
                              }}
                              <span class="text-danger">*</span></label>

                            <select class="form-control border border-dark" id="spousecob" placeholder="Select"
                              formControlName="spousecob" *ngIf="spousehealthcardinfo">
                              <option value="" [selected]="!userFormControl['spousecob'].value">{{ lang?.Select }}
                              </option>
                              <option value="SINGLE">{{ lang?.Single }}</option>
                              <option value="COUPLE">{{ lang?.Couple }}</option>
                              <option value="FAMILY">{{ lang?.Family }}</option>
                            </select>

                            <!-- <select class="form-control border border-dark" placeholder="Select" formControlName="childInfoGender">
                                              <option  value="" [selected]="!childFormGroup.get('childInfoGender')?.value" >{{ lang?.Select }}</option>
                                              <option value="Male">{{ lang?.Male }}</option>
                                              <option value="Female">{{ lang?.Female }}</option>
                                              <option value="Non-Binary">{{ lang?.Non_Binary }}</option>
                                              <option value="Undisclosed"> {{ lang?.Undisclosed }} </option>
                                            </select> -->

                            <div class="help-block text-danger" *ngIf="(userForm.get('spousecob')?.touched && userForm.get('spousecob')?.hasError('required'))
                                        || (userForm.get('spousecob')?.hasError('required') && myForm.submitted)">
                              {{ lang?.Please_select_name_of_COB_Coverage }}
                            </div>
                            <!-- <div class="help-block text-danger" *ngIf="
                                          userFormControl['spousecob'].touched &&
                                          userFormControl['spousecob'].invalid
                                        ">
                                          <div *ngIf="
                                            userFormControl['spousecob'].errors &&
                                            userFormControl['spousecob'].errors['required'] &&
                                            spousehealthcardinfo
                                          ">
                                            {{ lang?.Please_select_name_of_COB_Coverage }}
                                          </div>
                                        </div> -->
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- Spouce information end -->
                <!-- ******************************************************************************************************* -->
                <!-- Child information started from here -->

                <div class="row">
                  <!-- <div class="row"> -->
                  <div class="form-group col-12  ">
                    <b id="header-font">{{ lang?.Dependent_Children_Information }} <i class="fa fa-info-circle"
                        data-bs-target="#dependentChildInfoModal" data-bs-toggle="modal"></i></b>
                    <hr class="dependentChildInfoHrLine hrLineMargins">
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="col-12">
                      <label for=""> {{ lang?.Do_you_have_dependent_children }}<span
                          class="text-danger">*</span></label>
                    </div>
                    <!-- <div class="row"> -->
                    <div class="col-11">
                      <div class="form-check form-check-inline col-4 col-md-7">
                        <input class="form-check-input border border-dark" type="radio" name="Dependentchildren"
                          id="Dependentchildrenyes" value="true" [checked]="applicanthavingchildren === 'true'"
                          formControlName="Dependentchildren" data-bs-target="#childInfo"
                          (click)="havingchildren($event)" />
                        <label class="form-check-label" for="Dependentchildrenyes">{{ lang?.Yes }}</label>
                      </div>

                      <div class="form-check form-check-inline col-2">
                        <input class="form-check-input border border-dark" type="radio" name="Dependentchildren"
                          id="Dependentchildrenno" value="false" [checked]="applicanthavingchildren === 'false'"
                          formControlName="Dependentchildren" (click)="havingchildren($event)" />
                        <label class="form-check-label" for="Dependentchildrenno">{{ lang?.No}}</label>
                      </div>

                      <div class="help-block text-danger" *ngIf="
                                    (userForm.get('Dependentchildren')?.touched &&
                                      userForm
                                        .get('Dependentchildren')
                                        ?.hasError('required')) ||
                                    (userForm.get('Dependentchildren')?.invalid &&  myForm.submitted)">
                        {{ lang?.Please_choose_children_status }}
                      </div>
                      <div class="help-block text-danger"
                        *ngIf="userForm.get('Dependentchildren')?.value === 'true' && childTableRowsLength==0 && myForm.submitted">
                        {{lang?.Please_add_at_least_one_child}}
                      </div>

                    </div>
                  </div>

                  <!-- no of childrens flow start -->
                  <div class="col-12 col-md-6">
                    <div class="form-group col-8 col-md-8 d-flex"
                      *ngIf=" childrenhealthinformation &&  userForm.get('Dependentchildren')?.value === 'true'">

                      <div class="form-group col-6">
                        <div class="col-12">
                          <label class="" for="noofchildren">{{ lang?.No_of_Children }}<span
                              class="text-danger">*</span></label>
                        </div>
                        <input class="form-control border border-dark noofchildren" type="text" name="noofchildren"
                          id="noofchildren" [value]="noOfChildrenChangedValue" formControlName="noofchildren"
                          (change)="noofchildrenchanged($event)" maxlength="3"
                          onkeypress="return /^[0-9]+$/.test(event.key)" />
                        <div class="help-block text-danger"
                          *ngIf=" userFormControl['noofchildren'].touched && userFormControl['noofchildren'].invalid">
                          <div *ngIf="
                                          userFormControl['noofchildren'].errors &&
                                        userFormControl['noofchildren'].errors['required']">
                            {{ lang?.Please_enter_no_of_children }}
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-4 pt-3"
                        *ngIf=" childrenhealthinformation &&  userForm.get('Dependentchildren')?.value === 'true'">
                        <button type="button" data-bs-target="#childInfoModal"
                          class="btn btn-primary buttonBorder modalPopupHeaderAndButtonBgColor text-white backgroundColor ms-2 p-1"
                          (click)="childAddFun()">{{lang?.Add}}</button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Child information end here -->
                <!-- ******************************************************************************************************* -->

                <!-- child info table started -->
                <div class="row" *ngIf="childTableRowsLength>0">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr class="trbottomsolid">
                          <!-- <th class="bgColor-tr" scope="col">S.no</th> -->
                          <th class="bgColor-tr" scope="col">{{lang?.First_Name}}</th>
                          <th class="bgColor-tr" scope="col">{{lang?.Last_Name}}</th>
                          <th class="bgColor-tr" scope="col">{{lang?.Gender}}</th>
                          <th class="bgColor-tr" scope="col">{{lang?.Date_of_Birth}}</th>
                          <th class="bgColor-tr" scope="col">{{lang?.Action}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let childData of childInfoAddDataArray; let i = index">
                          <!-- <td class="thBottomNone"> {{i+1}}</td> -->
                          <td class="thBottomNone text-capitalize"> {{childData.childInfoFirstName}}</td>
                          <td class="thBottomNone text-capitalize"> {{childData.childInfoLastName}}</td>
                          <td class="thBottomNone"> {{childData.childInfoGender}}</td>
                          <td class="thBottomNone"> {{childData.childInfoDOB | date:"MM-dd-YYYY"}}</td>
                          <td class="thBottomNone">

                            <i class="bi bi-pencil-square childEditSymbleColor" (click)="childInforTableEdit(i)"></i>
                            <i class="bi bi-trash-fill ms-2 childDeleteSymbleColor" (click)="deleteChildrenSwal(i)"></i>


                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>


                <div class="form-row spouseinfogroup" *ngIf="showlandeddependentDetails">

                  <div class="form-group col-12 ">
                    <b id="header-font">{{lang?.Dependent_s_Information}}</b>
                    <div class="col-12 row ">
                      <div class="col-md-6">
                        <div>
                          <label>{{lang?.Is_Coverage_required_for_Dependent_s}}<span style="color: red">*</span></label>
                        </div>

                        <div class="form-check form-check-inline col-3">
                          <input class="form-check-input border border-dark" type="radio"
                            name="coverageRequiredOfDependents" id="coverageRequiredOfDependentsyes" value="true"
                            formControlName="coverageRequiredOfDependents" (change)="dependentCoverage($event)" />
                          <label class="form-check-label" for="coverageRequiredOfDependentsyes">{{lang?.Yes
                            }}</label>
                        </div>
                        <div class="form-check form-check-inline col-3">
                          <input class="form-check-input border border-dark" type="radio"
                            name="coverageRequiredOfDependents" id="coverageRequiredOfDependentsno" value="false"
                            formControlName="coverageRequiredOfDependents" (change)="dependentCoverage($event)" />
                          <label class="form-check-label" for="coverageRequiredOfDependentsno">{{lang?.No}}</label>

                        </div>
                        <div class="clearfix"></div>
                        <span class="help-block text-danger" *ngIf="
                                        (userForm.get('coverageRequiredOfDependents').touched &&
                                          userForm.get('coverageRequiredOfDependents').hasError('required')) ||
                                        (userForm.get('coverageRequiredOfDependents').hasError('required') &&
                                          myForm.submitted)
                                      ">{{lang?.Please_select_coverage_required_for_dependents_s}}</span>
                      </div>

                      <div *ngIf="showdependentdetails" class="col-md-12 row">
                        <div class="col-12 col-md-6 mt-2">
                          <label>{{lang?.Dependent_s_Date_of_Arrival_in_Canada}}<span
                              style="color: red">*</span></label>


                          <input type="text" class="form-control" formControlName="dependentdateOfArrival" *ngIf="true"
                            #dp placeholder="MM-DD-YYYY" value="{{ dependentdateOfArrival | date: 'MM-dd-yyyy'}}"
                            [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" bsDatepicker
                            [(bsValue)]="myDateValue2" [(ngModel)]="dependentdateOfArrival" />
                          <span class="help-block text-danger"
                            *ngIf="
                                                                  (userForm.get('dependentdateOfArrival').touched &&
                                                                    userForm.get('dependentdateOfArrival').hasError('required')) ||
                                                                  (userForm.get('dependentdateOfArrival').hasError('required') &&
                                                                    myForm.submitted)
                                                                ">{{lang?.Please_Select_date_of_arrival_in_Canada}}</span>
                        </div>
                        <div class="col-12 col-md-6 mt-2">
                          <div>
                            <label>{{lang?.Country_of_Origin}}<span style="color: red">*</span></label>
                          </div>

                          <select class="form-control" id="countryOrigin" placeholder="Select"
                            formControlName="dependentcountryOrigin">
                            <option value="" label="">{{lang?.Select}}</option>
                            <option *ngFor="let country of countries" [value]="country">{{country}}</option>
                          </select>
                          <div class="clearfix"></div>
                          <span class="help-block text-danger" *ngIf="
                              (userForm.get('dependentcountryOrigin').touched &&
                                userForm.get('dependentcountryOrigin').hasError('required')) ||
                              (userForm.get('dependentcountryOrigin').hasError('required') &&
                                myForm.submitted)
                            ">{{lang?.Please_select_dependent_s_country_of_Origin}}</span>
                        </div>
                        <div class="col-12 col-md-6 mt-2">
                          <div>
                            <label>{{lang?.Are_the_dependents_landed_immigrants}}<span
                                style="color: red">*</span></label>
                          </div>

                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio"
                              name="dependentLandedImigrant" id="dependentLandedImigrantyes" value="true"
                              formControlName="dependentLandedImigrant" (change)="dependentLandedImigrant($event)" />
                            <label class="form-check-label" for="dependentLandedImigrantyes">{{lang?.Yes }}</label>
                          </div>
                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio"
                              name="dependentLandedImigrant" id="dependentLandedImigrantno" value="false"
                              formControlName="dependentLandedImigrant" (change)="dependentLandedImigrant($event)" />
                            <label class="form-check-label" for="dependentLandedImigrantno">{{lang?.No}}</label>

                          </div>
                          <div class="clearfix"></div>
                          <span class="help-block text-danger"
                            *ngIf="
                                                                  (userForm.get('dependentLandedImigrant').touched &&
                                                                    userForm.get('dependentLandedImigrant').hasError('required')) ||
                                                                  (userForm.get('dependentLandedImigrant').hasError('required') &&
                                                                    myForm.submitted)
                                                                ">{{lang?.Please_Select_dependent_s_landed_immigrant}}</span>
                        </div>

                        <div *ngIf="showdependentlandedstatus" class="col-12 col-md-6 mt-2">
                          <div>
                            <label>{{lang?.Will_they_be_applying_for_landed_immigrant_status}}<span
                                style="color: red">*</span></label>
                          </div>


                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio"
                              name="dependentapplylandedstaus" id="dependentapplylandedstausyes" value="true"
                              formControlName="dependentapplylandedstaus" />
                            <label class="form-check-label" for="dependentapplylandedstausyes">{{lang?.Yes }}</label>
                          </div>
                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio"
                              name="dependentapplylandedstaus" id="dependentapplylandedstausno" value="false"
                              formControlName="dependentapplylandedstaus" />
                            <!-- (mouseover)="provincialhealthpopup() -->
                            <label class="form-check-label" for="dependentapplylandedstausno">{{lang?.No}}</label>
                          </div>
                          <div class="clearfix"></div>
                          <span class="help-block text-danger" *ngIf="
                                          (userForm.get('dependentapplylandedstaus').touched &&
                                            userForm.get('dependentapplylandedstaus').hasError('required')) ||
                                          (userForm.get('dependentapplylandedstaus').hasError('required') &&
                                            myForm.submitted)
                                        ">{{lang?.Please_Select_dependents_s_landed_status}}</span>
                        </div>

                        <div class="col-12 col-md-6 mt-2">
                          <div>
                            <label>{{lang?.Will_the_dependent_s_be_in_Canada_for_more_than_3_months}}<span
                                style="color: red">*</span></label>
                          </div>

                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio"
                              name="dependentMorethan3years" id="dependentMorethan3yearsyes" value="true"
                              formControlName="dependentMorethan3years" />
                            <label class="form-check-label" for="dependentMorethan3yearsyes">{{lang?.Yes }}</label>
                          </div>
                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio"
                              name="dependentMorethan3years" id="dependentMorethan3yearsno" value="false"
                              formControlName="dependentMorethan3years" />
                            <!-- (mouseover)="provincialhealthpopup() -->
                            <label class="form-check-label" for="dependentMorethan3yearsno">{{lang?.No}}</label>
                          </div>
                          <div class="clearfix"></div>
                          <span class="help-block text-danger" *ngIf="
                                        (userForm.get('dependentMorethan3years').touched &&
                                          userForm.get('dependentMorethan3years').hasError('required')) ||
                                        (userForm.get('dependentMorethan3years').hasError('required') &&
                                          myForm.submitted)
                                      ">{{lang?.Please_Select_status_of_dependent_s_in_Canada}}</span>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="d-flex justify-content-between mt-2 ">
                <div class="">
                  <button class="text-start" class="saveAndNext"
                    routerLink="/manageCorporates">{{lang?.Cancel}}</button>

                </div>

                <div class="">
                  <div class="text-end">
                    <button class="text-end" type="submit" class="saveAndNext" (click)="personalInfoSubmit()">
                      {{lang?.Next}}&nbsp;&nbsp;<i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>

            </form>

          </div>

          <div *ngIf="selectedTab === 'tab2' && customerPlansInActive!=true">

            <div class=" form-container linescrollbar">
              <!-- <div class="ms-4 firstname text-capitalize" style="font-size: 16px;" style="margin-top:12px">
                hi&nbsp;Admin,
              </div> -->
              <div class="ms-4 info_eligibility_plans" style="font-size: 16px;">{{completeapplicantinfo}}</div>
              <!-- {{(isStudent)}} -->
              <div *ngFor="let package of mainarrayFinal;let a =index" class="plansscreen">

                <span style="color:black">{{package?.name}}</span>

                <div class="wraptext">
                  <div *ngFor="let group of package.groups;let k=index">
                    <div *ngFor="let plan of group.plans; let i = index">
                      <div *ngIf="plan.insuranceType!='LIFE'">
                        <div class="package-groups col-md-4"
                          *ngFor="let product of plan.productAddonssNames; let r = index" title=""
                          [style.background-color]="plan.isBundle==false?plan.productAddonss[product][0]?.planlevel.backgroundColor:group.backgroundColor||'#5E172E'">

                          <span class="plantitle"> <span style="color: white"
                              *ngIf="group.categorization.paidByCompany==1">{{lang?.Company_Paid}}</span>
                            <span style=" color: white"
                              *ngIf="group.categorization.coveredByCompany==1">{{lang?.Upgrade_To}}</span>
                            <span style=" color: white"
                              *ngIf="group.categorization.paidByEmployee==1">{{lang?.Voluntary_Opt_In}}</span><br><span
                              style="padding-left:5px">{{product}}</span></span>

                          <div class="plancoverage ">
                            <div class="plansCoverageDetails row col-12"
                              *ngFor="let coverage of  plan.productAddonss[product]; let k = index">

                              <!-- <span class="overflow-ellipsis2" style="float: right; color: white"
                                *ngIf="group.categorization.paidByCompany==1">&nbsp;<span
                                  style="float:right;color:white;font-size: 14px;">{{
                                  currencySymbol}}0.00<small>*</small></span></span> -->



                              <div class="col-4" *ngIf="coverage?.display??false">
                                <span class="overflow-ellipsis" style="float: left; color: white"
                                  title={{coverage.planCoverageUI}}>

                                  <input type="checkbox"
                                    id="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][k].planlevel.id }}"

                                       class="plancheckbox{{ package.id }} plancv newPlan{{plan.id}} {{group.categorization.paidByCompany==1?'cp_plan':group.categorization.coveredByCompany==1?'cc_plan':'ep_plan'}} coverage{{coverage.planCoverageUI | uppercase}}"

   attr.data="{{ package.name }}##{{ group.name }}##{{
     plan.planCoverage
   }}##{{plan.productAddonss[product][k].calculatedTax.price}}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
     plan.frqMonthly
   }}##{{ package.optIn }}##{{
     group.disallowedPlanLevels
   }}##{{ group.parentId }}##{{ group.id }}##{{
     plan.name
   }}##{{ plan.planLevel }}##{{ plan.packageId }}##0##{{plan.planOptions}}##{{plan.productAddonss[product][k].id}}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}##{{plan.products && plan.products[k].upgradeCalculation?true:false}}"
                                    (change)="
                                             onCheckboxChange(
       $event,
       package.allowMultiple,
       plan.productAddonss[product][k].plan_level.disallowedPlanLevels,
       plan.planOptions,
       group.parentId,
       package.name,
       group.name,
       plan.planCoverage,
       0,
       0,
       0,
       0,
       $event,
       i,
       j,
       k,
       plan,
       plan.productAddonss[product][k],package,group
     )
                                          ">

                                  {{coverage.planCoverageUI}}</span><span class="clearfix"></span>
                              </div>
                              <div class="col-8" *ngIf="coverage?.display??false">
                                <span class="overflow-ellipsis2" style="float: right; color: white"
                                  *ngIf="group.categorization.paidByCompany==1">
                                  <span *ngIf="plan.products;else noProducts">
                                    <span *ngIf="plan.products[k] && plan.products[k].upgradeCalculation;else block1">
                                      <span
                                        *ngIf="plan.products[k].upgradeCalculation.deltaplanPrice<=0;else deltaplanPriceCheck">
                                        <span style="font-size: 14px;">{{lang.Employee_pays}} {{
                                          currencySymbol}}0.00<small>*</small></span>
                                      </span>
                                      <ng-template #deltaplanPriceCheck>
                                        <span
                                          style="font-size: 14px;float:right">{{lang.Employee_pays_through_payroll_deduction}}
                                          {{
                                          currencySymbol}}{{plan.products[k].upgradeCalculation.deltaplanPrice | number:
                                          "1.2-2"}}<small>*</small></span>
                                      </ng-template>
                                    </span>
                                    <ng-template #block1>
                                      <span *ngIf="plan.upgradeCalculation;else block2">
                                        <span *ngIf="plan.upgradeCalculation.deltaplanPrice<=0;else noDeltaplanPrice">
                                          <span style="font-size: 14px;">{{lang.Employee_pays}} {{
                                            currencySymbol}}0.00<small>*</small></span>

                                        </span>
                                        <ng-template #noDeltaplanPrice>
                                          <span
                                            style="font-size: 14px;float:right">{{lang.Employee_pays_through_payroll_deduction}}
                                            {{
                                            currencySymbol}}{{plan.upgradeCalculation.deltaplanPrice | number:
                                            "1.2-2"}}<small>*</small></span>
                                        </ng-template>
                                      </span>
                                    </ng-template>
                                    <ng-template #block2>
                                      <span>
                                        <span style="font-size: 14px;">{{lang.Employee_pays}} {{
                                          currencySymbol}}0.00<small>*</small></span>

                                      </span>

                                    </ng-template>


                                  </span>
                                  <ng-template #noProducts>
                                    <span style="font-size: 14px;">{{lang.Employee_pays}} {{
                                      currencySymbol}}0.00<small>*</small></span>

                                  </ng-template>
                                </span>

                                <span class="overflow-ellipsis2" style="float: right; color: white"
                                  *ngIf="group.categorization.coveredByCompany==1">
                                  <span style="float:right;color:white;font-size: 14px;">{{
                                    currencySymbol}}{{(plan.products?plan.products[k].upgradeCalculation.deltaplanPrice:plan.upgradeCalculation.deltaplanPrice)
                                    | number:
                                    "1.2-2"}}<small>*</small></span></span>
                                <span class="overflow-ellipsis2" style="float: right; color: white"
                                  *ngIf="group.categorization.paidByEmployee==1"><span
                                    style="float:right;color:white;font-size: 14px;">{{
                                    currencySymbol}}{{coverage.price |
                                    number: "1.2-2" }}<small>*</small></span></span>
                              </div>
                            </div>
                            <div class="taxes">
                              <span *ngIf="group.categorization.paidByCompany==1">*{{lang?.Employee_pays}}</span>
                              <span
                                *ngIf="group.categorization.coveredByCompany==1">*{{lang?.Employee_pays_through_payroll_deduction}}</span>
                              <span *ngIf="group.categorization.paidByEmployee==1"
                                class="my-2">*{{lang?.Employee_pays_through_CC_PAD}}</span>

                            </div>
                          </div>


                          <!-- Member -->





                        </div>
                      </div>

                      <div *ngIf="plan.insuranceType=='LIFE'">
                        <div class="cardLIFE1 plansscreen"
                          *ngFor="let product of plan.productAddonssNames ; let j = index" title=""
                          [style.background-color]="
                        plan.isBundle==false?plan.productAddonss[product][0].planlevel.backgroundColor:group.backgroundColor">

                          <span class="card-header" style="color:white">{{product}}</span>
                          <div class="row" *ngFor="let coverage of plan.productAddonss[product]; let k = index">


                            <div *ngIf="plan.insuranceType=='LIFE'">



                              <!-- Member -->


                              <div class="flex flex-col gap-2 text-xs mx-2 my-3">
                                <div style="display: flex;justify-content: space-between;color:white">
                                  <div class="font-semibold text-lg md:text-xl">
                                    {{lang.Total}}
                                  </div>
                                  <div class="text-end text-lg md:text-xl">
                                    <p class="text-end w-full outline-none">
                                      ${{
                                      allFormData[plan.planCoverage]?.total || 0
                                      | number : "1.2-2"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div style="display: flex;justify-content: space-between;color:white">

                                  <div class="col-span-3 flex gap-2 items-center">
                                    <input id="member" type="checkbox"
                                      attr.data="{{ package.name }}##{{ group.name }}##{{
                                                    plan.planCoverage
                                                  }}##{{
                                                    plan.productAddonss[product][k].calculatedTax.price
                                                  }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                    plan.frqMonthly
                                                  }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                    group.parentId
                                                  }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                    plan.packageId
                                                  }}##0##{{ plan.planOptions }}##{{
                                                    plan.productAddonss[product][k].id
                                                  }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}"
                                      name="{{ plan.planCoverage }}-member"
                                      id="planCheckLife{{ plan.planCoverage }}-MEMBER"
                                      class="w-6 h-6 my-auto flex-shrink-0 rounded cursor-pointer" (change)="
                                                                    onCheckboxChangeP(
                                                                      $event,
                                                                      plan.planCoverage,
                                                                      'member',
                                                                      'coverage',
                                                                      plan.productAddonss[product][k]
                                                                    )" />
                                    <label htmlFor="member"
                                      class="capitalize text-white w-full h-full label-text text-[12px]">
                                      {{lang.MEMBER}}
                                    </label>
                                  </div>
                                  <div class="col-span-1 text-white text-right font-semibold">
                                    <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none">
                                      ${{
                                      allFormData[ plan.planCoverage]?.member?.premium ||
                                      0 | number : "1.2-2"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="grid grid-cols-1 gap-2">
                                  <div class="col-span-1 text-base md:text-xl mt-3 text-[12px] text-white">
                                    <p>
                                      {{lang.In_the_last_12_months_have_you_used_in_any_form_whatsoever_tobacco_nicotine_or_cannabis_mixed_with_tobacco}}
                                    </p>

                                    <div class="grid grid-cols-3 mt-2" style="display:flex">
                                      <div class="flex justify-center items-center gap-2">
                                        <input id="yes" type="radio" class="member-{{ plan.planCoverage }}-yes"
                                          name="member-{{ plan.planCoverage }}"
                                          attr.data="{{ package.name }}##{{ group.name }}##{{
                                                        plan.planCoverage
                                                      }}##{{
                                                        plan.productAddonss[product][k].calculatedTax.price
                                                      }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                        plan.frqMonthly
                                                      }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                        group.parentId
                                                      }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                        plan.packageId
                                                      }}##0##{{ plan.planOptions }}##{{
                                                        plan.productAddonss[product][k].id
                                                      }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}" [disabled]="
                                                                        isDataAvailable(plan.planCoverage, 'member')
                                                                      "
                                          class="w-6 h-6 my-auto outline-none cursor-pointer" [checked]="
                                                                        allFormData[plan.planCoverage] &&
                                                                        allFormData[plan.planCoverage]['member'] &&
                                                                        allFormData[plan.planCoverage]['member'][
                                                                          'isSmoker'
                                                                        ] === 'yes'
                                                                      " value="yes" (change)="
                                                                        handleRadioChange(
                                                                          $event,
                                                                          plan.planCoverage,
                                                                          'member',plan.planOptions,plan,
                                                                          plan.productAddonss[product][k],package,group,plan.productAddonss[product][k].member
                                                                        )
                                                                      " />
                                        <label htmlFor="yes" class="w-full mr-2 text-white text-[12px]">
                                          {{lang.Yes}}
                                        </label>
                                      </div>
                                      <div class="flex justify-center items-center gap-2">
                                        <input id="no" type="radio" value="no" name="member-{{ plan.planCoverage }}"
                                          class="member-{{ plan.planCoverage }}-no" attr.data="{{ package.name }}##{{ group.name }}##{{
                                plan.planCoverage
                              }}##{{
                                plan.productAddonss[product][k].calculatedTax.price
                              }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                plan.frqMonthly
                              }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                group.parentId
                              }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                plan.packageId
                              }}##0##{{ plan.planOptions }}##{{
                                plan.productAddonss[product][k].id
                              }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}" [disabled]="
                                                                        isDataAvailable(plan.planCoverage, 'member')
                                                                      "
                                          class="w-6 h-6 my-auto outline-none cursor-pointer" [checked]="
                                                                        allFormData[plan.planCoverage] &&
                                                                        allFormData[plan.planCoverage]['member'] &&
                                                                        allFormData[plan.planCoverage]['member'][
                                                                          'isSmoker'
                                                                        ] === 'no'
                                                                      " (change)="
                                                                      handleRadioChange(
                                                                          $event,
                                                                          plan.planCoverage,
                                                                          'member',plan.planOptions,plan,
                                                                          plan.productAddonss[product][k],package,group,plan.productAddonss[product][k].member
                                                                        )
                                                                      " />
                                        <label htmlFor="no" class="w-full mr-2 text-white text-[12px]">
                                          {{lang.No}}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="">
                                    <div className="my-5 ">
                                      <p htmlFor="rangeSlider"
                                        class="block my-3 text-center font-semibold mb-2 text-[12px]"
                                        style="color:white">
                                        <!-- ${{ plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence | number }} -->
                                        ${{ plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence/1000 |
                                        number }}k


                                      </p>
                                      <div className="relative">
                                        <div *ngIf="
                                                                        plan.productAddonss[product][k].member.maximumCoverageWithEvidence &&
                                                                        plan.productAddonss[product][k].member.minimumCoverage
                                                                      " class="range-ticks flex justify-between mt-2">

                                        </div>
                                        <div class="range-slider-container">
                                          <div class="range-slider-wrapper">
                                            <input type="range"
                                              attr.data="{{ package.name }}##{{ group.name }}##{{
                                                        plan.planCoverage
                                                      }}##{{
                                                        plan.productAddonss[product][k].calculatedTax.price
                                                      }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                        plan.frqMonthly
                                                      }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                        group.parentId
                                                      }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                        plan.packageId
                                                      }}##0##{{ plan.planOptions }}##{{
                                                        plan.productAddonss[product][k].id
                                                      }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}"
                                              [disabled]="
                                                                        isDataAvailable(plan.planCoverage, 'member','isSmoker')
                                                                      " id="{{ plan.planCoverage }}-member-rangeSlider"
                                              name="{{
                                                                        plan.planCoverage
                                                                      }}-member-rangeSlider"
                                              [(ngModel)]="plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence"
                                              [ngModelOptions]="{standalone: true}" (change)="
                                                                        handleRangeChange(
                                                                          $event,
                                                                          plan.planCoverage,
                                                                          'member',plan.planOptions,plan,
                                                                          plan.productAddonss[product][k],package,group,$event,plan.productAddonss[product][k].member
                                                                        )
                                                                      " [min]="0"
                                              [max]="plan.productAddonss[product][k].member.maximumCoverageWithEvidence"
                                              [step]="plan.productAddonss[product][k].member.minimumCoverage" style="appearance: none;
                                              width: 100%;
                                              height: 10px;" [style.background]="getSliderBackground(
                                                  plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence,
                                                  plan.productAddonss[product][k].member.maximumCoverageWithEvidence,
                                                  plan.productAddonss[product][k].member.minimumCoverage,
                                                  plan.productAddonss[product][k].member.defaultRange
                                                )"
                                              class="my-2 border appearance-none w-full h-4 rounded-md focus:outline-none" />
                                            <p class="name-label leading-4 text-[10px]"
                                              [ngStyle]="{'width.%': greenValue}">{{lang.Guaranteed_Approval}}</p>


                                            <p *ngIf="showyellowbar" class="name-label leading-4  text-[10px]"
                                              [ngStyle]="{'right.%': 0}" style="top:-10px">
                                              {{lang.Pending_Approval}}</p>


                                            <div class="range-ticks1">
                                              <span *ngFor="let val of rangeValues" class="tick1"></span>
                                            </div>

                                          </div>
                                          <div class="range-labels">
                                            <span *ngFor="let val of rangeValues" class="range-label">${{ val/1000
                                              }}k</span>
                                          </div>

                                        </div>




                                      </div>

                                    </div>



                                    <br>
                                    <!-- } -->


                                  </div>
                                </div>
                              </div>


                              <!-- Spouse -->


                              <div class="flex flex-col gap-2 text-xs mx-2 my-3"
                                *ngIf="userForm.get('havingspouse')?.value === 'true'">
                                <div class="grid grid-cols-4 gap-2 lg:gap-4 items-center justify-between">
                                  <div class="col-span-3 flex gap-2 items-center">
                                    <input id="spouse" type="checkbox"
                                      attr.data="{{ package.name }}##{{ group.name }}##{{
                                                    plan.planCoverage
                                                  }}##{{
                                                    plan.productAddonss[product][k].calculatedTax.price
                                                  }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                    plan.frqMonthly
                                                  }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                    group.parentId
                                                  }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                    plan.packageId
                                                  }}##0##{{ plan.planOptions }}##{{
                                                    plan.productAddonss[product][k].id
                                                  }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}"
                                      id="planCheckLife{{ plan.planCoverage }}-SPOUSE"
                                      name="{{ plan.planCoverage }}-spouse"
                                      class="w-6 h-6 my-auto flex-shrink-0 rounded cursor-pointer"
                                      [disabled]="
                                                                        isDataAvailableSpouse(plan.planCoverage, 'member')" (change)="
                                                                    onCheckboxChangeP(
                                                                      $event,
                                                                      plan.planCoverage,
                                                                      'spouse',
                                                                      'coverage',
                                                                      plan.productAddonss[product][k]
                                                                    )
                                                                  " />
                                    <label htmlFor="spouse"
                                      class="mr-2 lg:mr-2 font-bold capitalize text-white w-full h-full label-text text-[12px] mt-3">
                                      {{lang?.SPOUSE}}
                                    </label>
                                  </div>



                                  <div class="col-span-1 text-white text-right font-semibold">
                                    <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none">
                                      ${{
                                      allFormData[plan.planCoverage]?.spouse?.premium ||
                                      0 | number : "1.2-2"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="grid grid-cols-1 gap-2">
                                  <div class="col-span-1 text-base md:text-xl mt-3 text-[12px] text-white">
                                    <p>
                                      {{lang.In_the_last_12_months_have_you_used_in_any_form_whatsoever_tobacco_nicotine_or_cannabis_mixed_with_tobacco}}

                                    </p>

                                    <div class="grid grid-cols-3 mt-2" style="display:flex">
                                      <div class="flex justify-center items-center gap-2">
                                        <input id="yes" type="radio" class="spouse-{{ plan.planCoverage }}-yes"
                                          attr.data="{{ package.name }}##{{ group.name }}##{{
                                                        plan.planCoverage
                                                      }}##{{
                                                        plan.productAddonss[product][k].calculatedTax.price
                                                      }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                        plan.frqMonthly
                                                      }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                        group.parentId
                                                      }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                        plan.packageId
                                                      }}##0##{{ plan.planOptions }}##{{
                                                        plan.productAddonss[product][k].id
                                                      }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}"
                                          [disabled]="
                                                                        isDataAvailableSpouseDataa(plan.planCoverage, 'spouse')
                                                                      " value="yes"
                                          name="spouse-{{ plan.planCoverage}}"
                                          class="w-6 h-6 my-auto outline-none cursor-pointer" [checked]="
                                                                        allFormData[plan.planCoverage] &&
                                                                        allFormData[plan.planCoverage]['spouse'] &&
                                                                        allFormData[plan.planCoverage]['spouse'][
                                                                          'isSmoker'
                                                                        ] === 'yes'
                                                                      " (change)="
                                                                      handleRadioChange(
                                                                          $event,
                                                                          plan.planCoverage,
                                                                          'spouse',plan.planOptions,plan,
                                                                          plan.productAddonss[product][k],package,group,plan.productAddonss[product][k].spouse
                                                                        )
                                                                      " />
                                        <label htmlFor="yes" class="w-full mr-2 text-white text-[12px]">
                                          {{lang.Yes}}
                                        </label>
                                      </div>
                                      <div class="flex justify-center items-center gap-2">

                                        <input id="no" type="radio" value="no" class="spouse-{{ plan.planCoverage }}-no"
                                          attr.data="{{ package.name }}##{{ group.name }}##{{
                                                        plan.planCoverage
                                                      }}##{{
                                                        plan.productAddonss[product][k].calculatedTax.price
                                                      }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                        plan.frqMonthly
                                                      }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                        group.parentId
                                                      }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                        plan.packageId
                                                      }}##0##{{ plan.planOptions }}##{{
                                                        plan.productAddonss[product][k].id
                                                      }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}"
                                          [disabled]="
                                                                        isDataAvailableSpouseDataa(plan.planCoverage, 'spouse')
                                                                      " name="spouse-{{ plan.planCoverage }}"
                                          class="w-6 h-6 my-auto outline-none cursor-pointer" [checked]="
                                                                        allFormData[plan.planCoverage] &&
                                                                        allFormData[plan.planCoverage]['spouse'] &&
                                                                        allFormData[plan.planCoverage]['spouse'][
                                                                          'isSmoker'
                                                                        ] === 'no'
                                                                      " (change)="
                                                                      handleRadioChange(
                                                                          $event,
                                                                          plan.planCoverage,
                                                                          'spouse',plan.planOptions,plan,
                                                                          plan.productAddonss[product][k],package,group,plan.productAddonss[product][k].spouse
                                                                        )
                                                                      " />
                                        <label htmlFor="no" class="w-full mr-2 text-white text-[12px]">
                                          {{lang.No}}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="">
                                    <div className="my-5">
                                      <p class="block my-3 text-center mb-2 font-semibold text-[12px]"
                                        style="color:white">
                                        ${{ plan.productAddonss[product][k].spouse.maximumCoverageWithoutEvidence/1000 |
                                        number }}k
                                      </p>
                                      <div className="relative">
                                        <div *ngIf="
                                                                        plan.productAddonss[product][k].spouse.maximumCoverageWithEvidence &&
                                                                        plan.productAddonss[product][k].spouse.minimumCoverage
                                                                      " class="range-ticks flex justify-between mt-2">

                                        </div>
                                        <div class="range-slider-container">
                                          <div class="range-slider-wrapper">
                                            <input type="range" class="spouse-{{ plan.planCoverage }}-no"
                                              attr.data="{{ package.name }}##{{ group.name }}##{{
                                                        plan.planCoverage
                                                      }}##{{
                                                        plan.productAddonss[product][k].calculatedTax.price
                                                      }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                        plan.frqMonthly
                                                      }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                        group.parentId
                                                      }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                        plan.packageId
                                                      }}##0##{{ plan.planOptions }}##{{
                                                        plan.productAddonss[product][k].id
                                                      }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}" [disabled]="
                                                                        isDataAvailable(plan.planCoverage, 'spouse','isSmoker')
                                                                      " id="{{ plan.planCoverage }}-spouse-rangeSlider"
                                              name="{{
                                                                        plan.planCoverage
                                                                      }}-spouse-rangeSlider"
                                              [(ngModel)]="plan.productAddonss[product][k].spouse.maximumCoverageWithoutEvidence"
                                              (change)="
                                                                      handleRangeChange(
                                                                          $event,
                                                                          plan.planCoverage,
                                                                          'spouse',plan.planOptions,plan,
                                                                          plan.productAddonss[product][k],package,group,$event,plan.productAddonss[product][k].spouse
                                                                        )
                                                                      " [min]="0"
                                              [max]="plan.productAddonss[product][k].spouse.maximumCoverageWithEvidence"
                                              [step]="plan.productAddonss[product][k].spouse.minimumCoverage" [ngStyle]="{
                                                                        background: getSliderBackground(
                                                                          plan.productAddonss[product][k].spouse.maximumCoverageWithoutEvidence,
                                                                          plan.productAddonss[product][k].spouse.maximumCoverageWithEvidence,
                                                                          plan.productAddonss[product][k].spouse.minimumCoverage,plan.productAddonss[product][k].member.defaultRange
                                                                        )
                                                                      }"
                                              class="my-2 border appearance-none w-full h-4 rounded-md focus:outline-none"
                                              style="appearance: none;
                                              width: 100%;
                                              height: 10px;" />
                                            <p class="name-label leading-4 text-[10px]"
                                              [ngStyle]="{'width.%': greenValue}">{{lang.Guaranteed_Approval}}</p>


                                            <p *ngIf="showyellowbar" class="name-label leading-4  text-[10px]"
                                              [ngStyle]="{'right.%': 0}" style="top:-10px">
                                              {{lang.Pending_Approval}}</p>

                                            <div class="range-ticks1">
                                              <span *ngFor="let val of rangeValues" class="tick1"></span>
                                            </div>

                                          </div>
                                          <div class="range-labels">
                                            <span *ngFor="let val of rangeValues" class="range-label">${{ val/1000
                                              }}k</span>
                                          </div>

                                        </div>
                                      </div>
                                    </div>


                                  </div>

                                </div>
                              </div>








                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>


              </div>

            </div>
            <div class="d-flex justify-content-between mt-2">
              <button type="submit" class="saveAndNext" (click)="selectTab('tab1')"> <i aria-hidden="true"
                  class="fa fa-chevron-left"></i>
                {{lang?.Previous}}
              </button>
              <button type="submit" class="saveAndNext" [disabled]="plansnexttab" (click)="paymentpage(3)">
                {{lang?.Next}}&nbsp;&nbsp;<i class="fa fa-chevron-right" aria-hidden="true"></i>
              </button>

            </div>

          </div>

          <div *ngIf="selectedTab === 'tab3' && customerPlansInActive===true">
            <div class="form-container linescrollbar">
              <!-- <div class="firstname text-capitalize" style="font-size: 16px;">hi&nbsp;Admin,</div> -->
              <!-- <div class=" info_eligibility_plans" style="font-size: 16px;">{{completeapplicantinfo}}</div> -->
              <!-- Table for  -->

              <div class="mt-4">
                <p class="headings">{{lang?.Plans_Enrolled}}</p>
                <table class="table table-bordered border-1 border-black mt-1">
                  <thead>
                    <tr>
                      <th>{{lang?.Plan_Name}}</th>
                      <th>{{lang?.Coverage}}</th>
                      <th class="text-center">{{lang?.Amount}}</th>
                      <th>{{lang?.Date}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let plan of customerPlansActiveData">
                      <ng-container *ngFor="let product of plan.subscriptionProducts">
                        <tr *ngIf="plan.planName !== 'Taxes' && product.isIncluded===true">
                          <td>{{ plan.planName }}</td>
                          <td>{{ product.planProduct.productName }}</td>
                          <td class="text-center">{{ plan.amount }}</td>
                          <td>{{ (plan.scheduledActivationTimestamp||plan.activatedTimestamp) | date:"MM-dd-YYYY"}}
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>

              <form action="https://payments.subscriptionplatform.com/v2/payments/create" method="post"
                #enrollmentForms1 #enrollmentForms="ngForm" [formGroup]="enrollmentForm" class="mt-2">
                <div class="container">

                  <div class="row">
                    <div class="col-12 mt-1">
                      <label for="" class="mt-1">{{lang?.Payment_Method}}</label>
                      <div class="form-check"><input type="radio" name="paymentMethodSelection"
                          class="form-check-input mt-1" (change)="paymentMethodSelect('Pre-Authorized')"> <label
                          for="">{{lang?.Pre_authorized_Debit}}</label>
                      </div>
                      <div class="form-check"><input type="radio" name="paymentMethodSelection"
                          class="form-check-input border border-dark" (change)="paymentMethodSelect('Credit_Card')"
                          checked>
                        <label for="">{{lang?.Credit_Card}}</label>
                      </div>
                    </div>
                  </div>

                  <div class="form-row mt-2">
                    <div class="form-group d-flex">
                      <input type="checkbox" class="form-check-input border border-dark"
                        formArrayName="homeAddressSameasBillingAddress" [checked]="homeaddresscheckvalue"
                        (change)="homeaddressEnrollment($event)">
                      <label for="" class="ms-1">{{lang?.Home_address_is_the_same_as_billing_address}}</label>
                    </div>
                  </div>

                  <div *ngIf="!homeaddressEnrollmentVal">
                    <div class="row">
                      <div class="form-group mt-1 col-12 col-md-6 mt-2">
                        <label for="">{{lang?.Unit_Apt_Suite}}</label>
                        <input type="text" class="form-control border border-dark text-capitalize"
                          placeholder="{{lang?.Unit_Apt_Suite}}" formControlName="enrollmentSummaryApartSuite">
                        <div class="help-block text-danger"
                          *ngIf="enrollmentForm.get('enrollmentSummaryApartSuite')?.touched && enrollmentForm.get('enrollmentSummaryApartSuite')?.hasError('aptexpression')">
                          {{lang?.Please_enter_valid_Unit_Apt_Suite_number}}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6 mt-1">
                        <label for="">{{lang?.Street_Address}} <span class="text-danger">*</span></label>
                        <input type="text" class="form-control border border-dark text-capitalize"
                          placeholder="{{ lang?.Street_Address }}" formControlName="enrollmentSummaryStreetAddress" />

                        <div class="help-block text-danger"
                          *ngIf="(enrollmentForm.get('enrollmentSummaryStreetAddress')?.touched &&
                                            enrollmentForm.get('enrollmentSummaryStreetAddress')?.hasError('required')) ||
                                            (enrollmentForm.get('enrollmentSummaryStreetAddress')?.hasError('required') && enrollmentForms.submitted)">
                          {{ lang?.Please_enter_Street_Address }}
                        </div>

                      </div>
                      <div class="col-12 col-md-6 mt-1">
                        <label for="">{{lang?.Street_Address_Line_2}} </label>
                        <input type="text" class="form-control border border-dark"
                          placeholder="{{lang?.Street_Address_Line_2}}"
                          formControlName="enrollmentSummaryStreetAddressLane2">

                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-md-4 mt-1">
                        <label for="">{{lang?.City}} <span class="text-danger">*</span></label>
                        <input type="text" class="form-control border border-dark text-capitalize"
                          placeholder="{{lang?.City}}" formControlName="enrollmentSummaryCity">


                        <div class="help-block text-danger"
                          *ngIf="(enrollmentForm.get('enrollmentSummaryCity')?.touched &&
                                              enrollmentForm.get('enrollmentSummaryCity')?.hasError('required')) ||
                                              (enrollmentForm.get('enrollmentSummaryCity')?.hasError('required') && enrollmentForms.submitted)">
                          {{ lang?.Please_enter_City }}
                        </div>

                      </div>

                      <div class="col-12 col-md-4 mt-1">
                        <label for="">{{lang?.Province}} <span class="text-danger">*</span></label>
                        <select type="text" class="form-select border border-dark"
                          formControlName="enrollmentSummaryProvince" (change)="provinceEnrollmentlist($event)">
                          <option value="null" [selected]="!enrollmentFormControl['enrollmentSummaryProvince']?.value">
                            {{lang?.Select}}</option>
                          <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                            {{ name.shortName }}
                          </option>
                        </select>


                        <div class="help-block text-danger"
                          *ngIf="(enrollmentForm.get('enrollmentSummaryProvince')?.touched &&
                                          enrollmentForm.get('enrollmentSummaryProvince')?.hasError('required')) ||
                                                (enrollmentForm.get('enrollmentSummaryProvince')?.hasError('required') && enrollmentForms.submitted)">
                          {{ lang?.Please_select_Province }}
                        </div>

                      </div>

                      <div class="col-12 col-md-4 mt-1">
                        <label>{{lang?.Postal_Code}} <span class="text-danger">*</span></label>

                        <input type="text" class="form-control checking-field border border-dark"
                          placeholder="{{ lang?.Postal_Code }}" formControlName="enrollmentSummaryPostalCode"
                          (input)="changeTextToUppercaseenrollmentPostalCode('enrollmentSummaryPostalCode',$event)" />

                        <div class="help-block text-danger"
                          *ngIf="(enrollmentForm.get('enrollmentSummaryPostalCode')?.touched &&
                                            enrollmentForm.get('enrollmentSummaryPostalCode')?.hasError('required')) ||
                                                  (enrollmentForm.get('enrollmentSummaryPostalCode')?.hasError('required') && enrollmentForms.submitted)">
                          {{ lang?.Please_enter_postal_code }}
                        </div>

                        <div class="help-block text-danger" *ngIf="
                                            (enrollmentForm.get('enrollmentSummaryPostalCode')?.touched &&
                                            enrollmentForm .get('enrollmentSummaryPostalCode')?.hasError('invalidPostalCode')) ||
                                            (!enrollmentForm.get('enrollmentSummaryProvince')?.hasError('required') && invalidenrollmentpostalcodeprovince)
                                          ">{{ lang?.Please_enter_valid_postal_code }}</div>


                      </div>
                    </div>
                  </div>


                </div>

              </form>


              <!-- <div class="mt-4">
                        <p class="headings">Enrollment Summary</p>
                        <table class="table table-bordered border-1 border-black mt-1">
                          <thead>
                            <tr>
                              <th>Plan Name</th>
                              <th>Plan Product</th>
                              <th>Amount</th>
                              <th>Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let plan of customerPlansActiveData">
                              <ng-container *ngFor="let product of plan.subscriptionProducts">
                                <tr *ngIf="plan.planName !== 'Taxes' && product.isIncluded===true">
                                  <td>{{ plan.planName }}</td>
                                  <td>{{ product.planProduct.productName }}</td>
                                  <td>{{ plan.amount }}</td>
                                  <td>{{ (plan.scheduledActivationTimestamp||plan.activatedTimestamp) | date:"MM-dd-YYYY"}}</td>

                                </tr>
                              </ng-container>
                            </ng-container>
                          </tbody>
                        </table>
                      </div> -->

            </div>

            <div class="form-row d-flex justify-content-between mt-2">
              <button type="submit" class="saveAndNext" (click)="selectTab('tab1')"> <i aria-hidden="true"
                  class="fa fa-chevron-left"></i>
                {{lang?.Previous}}
              </button>

              <div class="form-row text-end  ">
                <button type="submit" class="saveAndNext" (click)="enrollmentForActivePlans()">
                  {{lang?.Submit}}&nbsp;&nbsp;<i class="fa fa-chevron-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>

          </div>

          <!-- tab3 enrollment summary -->
          <div *ngIf="selectedTab === 'tab3' && customerPlansInActive!=true">
            <div class=" form-container linescrollbar">
              <div class="row mt-4">
                <div class="form-group col-12">
                  <b style="float: left;" id="header-font">{{lang?.SELECTED_PLANS}}</b>
                  <hr class="employeeInfoHrLine hrLineMargins">
                </div>
              </div>

              <!-- ************* Plans table ******************* -->
              <div class="row mt-2">

                <div class="main" style="flex: 1; padding: 18.5px; overflow-x: auto">
                  <!-- <div class="form-row" *ngIf="!singleSummaryTable && (companySelectedPlans.length == 0 ? false : true)">
                                <div class="form-group col-md-12">
                                  <label for="cardnumnber"><strong>{{lang1.core_plans_premium_paid_100%_by_employer}}</strong></label>

                                  <div class="table-responsive">

                                    <table class="table table-bordered" id="customerPlansTable">
                                      <tbody>
                                        <tr>

                                          <th>{{lang?.Plan}}</th>

                                          <th class="taxamount">{{lang1.amount}}({{lang1.company}})</th>

                                          <th class="taxamount">{{lang1.tax}}</th>
                                          <th class="taxamount">{{lang?.Total}}</th>
                                        </tr>
                                        <tr
                                          *ngFor="
                                              let item of companySelectedPlans;
                                              let i = index
                                            ">


                                          <td>{{ item.planname }}<br />({{ item.packagename }})</td>

                                          <td class="taxamount">
                                            {{ currencySymbol }}{{ item.planPrice | number: "1.2-2" }}
                                          </td>

                                          <td class="taxamount">
                                            <span *ngIf="item.gstCheck" class="gsttaxes"
                                              >{{ item.gstPrice == 0 ? "-" : currencySymbol + (item.gstPrice |
                                              number: "1.2-2") + "&nbsp;(GST)" }}</span
                                            ><span *ngIf="item.pstCheck" class="gsttaxes"
                                              >{{ item.pstPrice == 0 ? "-" : currencySymbol + (item.pstPrice |
                                              number: "1.2-2") + "&nbsp;(PST)" }}</span
                                            ><span *ngIf="item.hstCheck" class="gsttaxes"
                                              >{{ item.hstPrice == 0 ? "-" : currencySymbol + (item.hstPrice |
                                              number: "1.2-2") + "&nbsp;(HST)" }}</span
                                            ><span
                                              *ngIf="
                                                  !item.gstCheck &&
                                                  !item.pstCheck &&
                                                  !item.hstCheck
                                                "
                                              >-</span
                                            >
                                          </td>
                                          <td class="grandTotal">
                                            {{ currencySymbol }}{{ item.totalPrice | number: "1.2-2" }}
                                          </td>
                                        </tr>

                                        <tr>
                                            <td>{{lang?.Total}}</td>
                                            <td colspan="2"></td>
                                            <td class="grandTotal">
                                             <b>{{ currencySymbol
                                              }}{{ companyPaidTotal}}</b>
                                            </td>
                                          </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div> -->
                  <br />
                  <!-- <div  class="form-row"
                                *ngIf="!singleSummaryTable && (companyCoveredPlans.length == 0 ? false : true)"
                                class="form-row">
                                <div class="form-group col-md-12">
                                  <label for="cardnumnber"
                                    ><strong
                                      >{{lang1.upgrade_plans_premium_difference_payroll_deduction}}</strong
                                    ></label
                                  >

                                  <div>
                                    <table class="table table-bordered" id="customerPlansTable">
                                      <tbody>
                                        <tr>
                                          <th>{{lang?.Plan}}</th>

                                          <th class="taxamount">{{lang1.amount}}<br>({{lang1.company}}+{{lang1.employee}})</th>

                                          <th class="taxamount">{{lang1.tax}}</th>
                                          <th class="taxamount">{{lang?.Total}}</th>
                                        </tr>
                                        <ng-container *ngFor="
                                        let item of companyCoveredPlans;
                                        let i = index
                                      ">
                                      <tr class="main-details-ccplan-tr">

                                      <td>{{i+1}}. {{ item.planname }}     <br>({{ item.packagename }})     </td>
                                      <td class="taxamount">
                                        {{ currencySymbol }}{{ item.planPrice | number: "1.2-2"
                                        }}
                                      </td>
                                      <td class="taxamount">
                                        <span *ngIf="item.gstCheck" class="gsttaxes"
                                          >{{ item.gstPrice == 0 ? "-" : currencySymbol + (item.gstPrice |
                                          number: "1.2-2") + "&nbsp;(GST)" }}</span
                                        ><span *ngIf="item.pstCheck" class="gsttaxes"
                                          >{{ item.pstPrice == 0 ? "-" : currencySymbol + (item.pstPrice |
                                          number: "1.2-2") + "&nbsp;(PST)" }}</span
                                        ><span *ngIf="item.hstCheck" class="gsttaxes"
                                          >{{ item.hstPrice == 0 ? "-" : currencySymbol + (item.hstPrice |
                                          number: "1.2-2") + "&nbsp;(HST)" }}</span
                                        ><span
                                          *ngIf="
                                            !item.gstCheck &&
                                            !item.pstCheck &&
                                            !item.hstCheck
                                          "
                                          >-</span
                                        ></td>
                                        <td class="grandTotal">
                                          {{ currencySymbol }}{{ item.totalPrice | number: "1.2-2" }}
                                          </td>
                                        </tr>
                                        <tr class="additional-details-ccplan-tr">

                                          <td>Base Plan paid by company <br> {{item.companyCoveredBasePlan.planName}}</td>
                                          <td>
                                             Company share from base plan -      <i [innerHTML]="item.companyCoveredBasePlan.amount | number: '1.2-2'"></i>
                                            <br> Employee share deducted from salary- <i [innerHTML]="item.employeeDeductions.amount | number: '1.2-2'"></i>
                                          </td>
                                          <td>
                                           Company share from base plan -
                                           [{{item.companyCoveredBasePlan.tax}}]
                                            <br> Employee share deducted from salary-
                                            [{{item.employeeDeductions.tax}}]
                                          </td>
                                          <td>   Company share from base plan -       <i [innerHTML]="item.companyCoveredBasePlan.total | number: '1.2-2'"></i>
                                            <br> Employee share deducted from salary- <i [innerHTML]="item.employeeDeductions.total | number: '1.2-2'"></i>
                                        </tr>
                                    </ng-container>
                                         <tr
                                          >
                                         <td>{{i+1}}</td> --
                                          {{item.groupName | lowercase}}- --

                                          <td>{{ item.planname }}
                                            <br />({{ item.packagename }})
                                            <br />--------------------
                                            <br>
                                          </td>
                                          <td>{{item.companyAmountUI}}</td>
                                            <td>{{item.employeeAmountUI}}</td> --
                                          <td class="taxamount">
                                            {{ currencySymbol }}{{ item.planPrice | number: "1.2-2"
                                            }}
                                            <br />--------------------
                                            <span>
                                            <br> Company share from base plan -       {{item.companyCoveredBasePlan.amountUI}}
                                            <br> Employee share deducted from salary- {{item.employeeDeductions.amountUI}}
                                          </span>
                                          </td>
                                          <td>{{item.planCoverage}}</td> --
                                          <td class="taxamount">
                                            <span *ngIf="item.gstCheck" class="gsttaxes"
                                              >{{ item.gstPrice == 0 ? "-" : currencySymbol + (item.gstPrice |
                                              number: "1.2-2") + "&nbsp;(GST)" }}</span
                                            ><span *ngIf="item.pstCheck" class="gsttaxes"
                                              >{{ item.pstPrice == 0 ? "-" : currencySymbol + (item.pstPrice |
                                              number: "1.2-2") + "&nbsp;(PST)" }}</span
                                            ><span *ngIf="item.hstCheck" class="gsttaxes"
                                              >{{ item.hstPrice == 0 ? "-" : currencySymbol + (item.hstPrice |
                                              number: "1.2-2") + "&nbsp;(HST)" }}</span
                                            ><span
                                              *ngIf="
                                                !item.gstCheck &&
                                                !item.pstCheck &&
                                                !item.hstCheck
                                              "
                                              >-</span
                                            >

                                             <br />--------------------
                                            <p>
                                            <br> Company share from base plan -       {{item.companyCoveredBasePlan.taxUI}}
                                            <br> Employee share deducted from salary- {{item.employeeDeductions.taxUI}}
                                            </p>
                                          </td>
                                          <td class="grandTotal">
                                            {{ currencySymbol }}{{ item.totalPrice | number: "1.2-2" }}
                                            <br />--------------------
                                            <p>
                                            <br> Company share from base plan -       {{item.companyCoveredBasePlan.totalUI}}
                                            <br> Employee share deducted from salary- {{item.employeeDeductions.totalUI}}
                                            </p>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>Total(All plans)</td>

                                          <td class="grandTotal" colspan="3">
                                          <b>    {{ currencySymbol
                                            }}{{ companyCoveredTotal | number: '1.2-2'}}</b>
                                            <br />--------------------
                                            <p>
                                            <br> Company share from all base plans -      {{ currencySymbol
                                            }}{{companyCoveredCompanyShareTotal | number: '1.2-2'}}
                                            <br> Employee share from all plans deducted from salary- {{ currencySymbol
                                            }}{{companyCoveredEmployeeShareTotal | number: '1.2-2'}}
                                          </p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div> -->
                  <br />
                  <div class="form-row"
                    *ngIf="!singleSummaryTable && (EmployeeSelectedPlans.length == 0 ? false : true)">
                    <div class="form-group col-md-12">
                      <label
                        for="cardnumnber"><strong>{{lang?.Voluntary_Plans_Premium_paid_100_by_employee_directly}}</strong></label>

                      <div>
                        <table class="table table-bordered" id="customerPlansTable">
                          <tbody>
                            <tr>
                              <!-- <th>S. no</th> -->
                              <th>{{lang?.Plan}}</th>
                              <!-- <th>Company Share</th>
                                        <th>Employee Share</th> -->
                              <th>{{lang?.Type}}</th>
                              <th class="taxamount">{{lang?.Amount}}&nbsp;{{lang?.Employee}}</th>
                              <!-- <th>Employee paid</th> -->
                              <!-- <td>Plan</td> -->
                              <th class="taxamount">{{lang?.Tax}}</th>
                              <th class="taxamount">{{lang?.Total}}</th>
                            </tr>
                            <tr *ngFor="
                                          let item of EmployeeSelectedPlans;
                                          let i = index
                                        ">
                              <td>{{ item.planname }}<br />({{ item.packagename }})</td>
                              <td>Employee paid</td>

                              <td class="taxamount">
                                {{ currencySymbol }}{{ item.planPrice | number: "1.2-2"
                                }}
                              </td>

                              <!-- <td>{{item.planCoverage}}</td> -->
                              <td class="taxamount">

                                <span *ngIf="item.tax ; else withoutTax">{{currencySymbol}}{{item.tax|
                                  number:"1.2-2"}}</span>
                                <ng-template #withoutTax>
                                  <span>0</span>
                                </ng-template>
                              </td>

                              <td class="grandTotal">
                                {{ currencySymbol }}{{ item.totalPrice | number: "1.2-2" }}
                              </td>

                            </tr>

                            <tr>
                              <td>{{lang?.Total}}</td>
                              <td colspan="2"></td>
                              <td class="grandTotal">
                                <b> {{ currencySymbol
                                  }}{{ paidEmployeedTotal | number: "1.2-2" }}</b>
                              </td>

                            </tr>
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                  <!-- <br>
                              <h6>Total effective cost for employee directly or indirectly : {{ currencySymbol
                              }}{{effectiveEmployeeTotalContibution}}</h6>
                              <br> -->
                  <div class="form-row" *ngIf="singleSummaryTable && allSelectedPlans.length == 0 ? false : true">
                    <div class="form-group col-md-12">
                      <label for="cardnumnber"><strong>{{lang?.All_selected_plans_summary}}</strong></label>

                      <div>
                        <table class="table table-bordered" id="customerPlansTable">
                          <tbody>
                            <tr>
                              <!-- <th>S. no</th> -->
                              <th>{{lang?.Plan}}</th>
                              <!-- <th>Company Share</th>
                                            <th>Employee Share</th> -->
                              <th>{{lang?.Type}}</th>
                              <th class="taxamount">{{lang?.Premium}}</th>
                              <!-- <td>Plan</td> -->
                              <!-- <th class="taxamount">Tax Percentage</th> -->

                              <th class="taxamount">{{lang.Tax}}</th>
                              <th class="taxamount">{{lang.Total}}</th>
                            </tr>
                            <tr *ngFor="
                                              let item of allSelectedPlans;
                                              let i = index
                                            ">
                              <!-- <td>{{i+1}}</td> -->
                              <!-- {{item.groupName | lowercase}}- -->
                              <td *ngIf="item.isBundle==true;else productname">

                                <!-- ({{ item.packagename }}) -  -->
                                <span *ngIf="item.coveredByCompany==1;else noupgrade">{{
                                  item.upgradeCalculation.planName
                                  }}</span>
                                <ng-template #noupgrade>{{item.planname}}</ng-template>

                              </td>

                              <ng-template #productname>
                                <td>
                                  <!-- ({{ item.packagename }}) -  -->
                                  <span *ngIf="item.coveredByCompany==1;else noupgrade1">{{
                                    item.upgradeCalculation.planName }}</span>
                                  <ng-template #noupgrade1>{{item.planproductname}}</ng-template>
                                </td>
                              </ng-template>

                              <!-- <td>{{item.companyAmountUI}}</td>
                                            <td>{{item.employeeAmountUI}}</td> -->
                              <td>{{item.type}}</td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">

                                <span *ngIf="item.coveredByCompany==1;else noupgradeprice">{{ currencySymbol }}{{
                                  item.upgradeCalculation.combinedplanPrice | number: "1.2-2"}}</span>
                                <ng-template #noupgradeprice>{{ currencySymbol }}{{ item.planPrice | number: "1.2-2"
                                  }}</ng-template>

                              </td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>


                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <span *ngIf="item.coveredByCompany==1;else noupgradetax">{{ currencySymbol }}{{
                                  item.upgradeCalculation.combinedplanTax | number: "1.2-2"}}</span>
                                <ng-template #noupgradetax>{{ currencySymbol }}{{item.tax | number:
                                  "1.2-2"}}</ng-template>

                              </td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>

                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <span *ngIf="item.coveredByCompany==1;else noupgradetotal">{{ currencySymbol }}{{
                                  item.upgradeCalculation.combinedplanTotal | number: "1.2-2"}}</span>
                                <ng-template #noupgradetotal>{{ currencySymbol }}{{ item.totalPrice | number: "1.2-2"
                                  }}</ng-template>

                              </td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                            </tr>

                            <tr style="background-color: rgb(20,42,73);color:white">
                              <td>{{lang?.Total}}</td>
                              <td></td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">{{ currencySymbol}}{{
                                allPlansAmountTotal | number: "1.2-2"
                                }}</td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">{{ currencySymbol
                                }}{{allPlansTotaltax | number: "1.2-2"}}</td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <b>{{ currencySymbol
                                  }}{{ allPlansTotal | number: "1.2-2" }}</b>
                              </td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                            </tr>


                            <tr>
                              <td>
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr style="background-color: black">
                              <td style="color:black">{{lang?.Monthly_Payment_Summary}}
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                            <tr *ngIf="companyDealingPlans.length == 0 ? false : true">
                              <td><b>{{lang?.Company_Pays}}</b>
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr *ngFor="let companypay of companyDealingPlans">

                              <td>
                                <span
                                  *ngIf="companypay.upgradeCalculation;else normalname">{{companypay.upgradeCalculation.compnayShareStatement}}</span>
                                <ng-template #normalname>
                                  {{companypay.planproductname}}
                                </ng-template>

                              </td>
                              <td>{{companypay.type}}</td>

                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <span *ngIf="companypay.upgradeCalculation;else normalamount">{{ currencySymbol
                                  }}{{ companypay.upgradeCalculation.baseplanPrice | number: "1.2-2" }}</span>
                                <ng-template #normalamount>
                                  {{ currencySymbol
                                  }}{{ companypay.amount | number: "1.2-2" }}
                                </ng-template>
                              </td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <span *ngIf="companypay.upgradeCalculation;else normaltax">{{ currencySymbol
                                  }}{{ companypay.upgradeCalculation.baseplanTax | number: "1.2-2" }}</span>

                                <ng-template #normaltax>
                                  {{ currencySymbol
                                  }}{{ companypay.tax | number: "1.2-2" }}
                                </ng-template>
                              </td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <span *ngIf="companypay.upgradeCalculation;else normaltotal">
                                  <b>{{ currencySymbol}}{{ companypay.upgradeCalculation.baseplanTotal | number: "1.2-2"
                                    }}</b></span>

                                <ng-template #normaltotal>
                                  <b>{{ currencySymbol
                                    }}{{ companypay.total | number: "1.2-2" }}</b>
                                </ng-template>
                              </td>
                              <td class="grandTotal amounts" *ngIf="employercheck">
                                ---
                              </td>
                            </tr>

                            <tr *ngIf="payrollCCplansarr.length == 0 ? false : true">
                              <td><b>{{lang?.Employee_pays_through_payroll_deduction}}</b>
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr *ngFor="let companypay of payrollCCplansarr">

                              <td>
                                <span
                                  *ngIf="companypay.upgradeCalculation;else normalname">{{companypay.upgradeCalculation.employeeShareStatement}}</span>
                                <ng-template #normalname>
                                  {{companypay.planname}}
                                </ng-template>

                              </td>
                              <td>{{companypay.type}}</td>

                              <td class="grandTotal amounts">
                                <span *ngIf="companypay.upgradeCalculation;else normalamount">{{ currencySymbol
                                  }}{{ companypay.upgradeCalculation.deltaplanPrice | number: "1.2-2" }}</span>
                                <ng-template #normalamount>
                                  {{ currencySymbol
                                  }}{{ companypay.amount | number: "1.2-2" }}
                                </ng-template>
                              </td>

                              <td class="grandTotal amounts">
                                <span *ngIf="companypay.upgradeCalculation;else normaltax">{{ currencySymbol
                                  }}{{ companypay.upgradeCalculation.deltaplanTax | number: "1.2-2" }}</span>

                                <ng-template #normaltax>
                                  {{ currencySymbol
                                  }}{{ companypay.tax | number: "1.2-2" }}
                                </ng-template>
                              </td>

                              <td class="grandTotal amounts">
                                <span *ngIf="companypay.upgradeCalculation;else normaltotal">
                                  <b>{{ currencySymbol}}{{ companypay.upgradeCalculation.deltaplanTotal | number:
                                    "1.2-2"
                                    }}</b></span>

                                <ng-template #normaltotal>
                                  <b>{{ currencySymbol
                                    }}{{ companypay.total | number: "1.2-2" }}</b>
                                </ng-template>
                              </td>

                            </tr>

                            <tr style="background-color: rgb(20,42,73);color:white">

                              <td>{{lang?.Total_charge_to_Company}}</td>
                              <td></td>
                              <td class="grandTotal amounts" *ngIf="!employercheck">{{ currencySymbol
                                }}{{ companydealingplansTotal | number: "1.2-2" }}</td>
                              <td class="grandTotal amounts" *ngIf="employercheck">---</td>

                              <td class="grandTotal amounts" *ngIf="!employercheck">{{ currencySymbol
                                }}{{ companydealingplanstaxTotal | number: "1.2-2" }}</td>
                              <td class="grandTotal amounts" *ngIf="employercheck">---</td>

                              <td class="grandTotal amounts" *ngIf="!employercheck">
                                <b>{{ currencySymbol
                                  }}{{ companydealingplansgrandTotal | number: "1.2-2" }}</b>
                              </td>
                              <td class="grandTotal amounts" *ngIf="employercheck">---</td>

                            </tr>
                            <tr>
                              <td>
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr *ngIf="employeeDealingPlansarr.length == 0 ? false : true">
                              <td><b>{{lang?.Employee_pays_through_CC_PAD}} </b>
                              <td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr *ngFor="let companypay of employeeDealingPlansarr">

                              <td>
                                <!-- <span *ngIf="companypay.upgradeCalculation;else normalname">{{companypay.upgradeCalculation.compnayShareStatement}}</span> -->
                                <!-- <ng-template > -->
                                {{companypay.planname}}
                                <!-- </ng-template> -->

                              </td>
                              <td>{{companypay.type}}</td>

                              <td class="grandTotal amounts">
                                <!-- <span *ngIf="companypay.upgradeCalculation;else normalamount">{{ currencySymbol
                                              }}{{ companypay.upgradeCalculation.deltaplanPrice | number: "1.2-2" }}</span> -->
                                <!-- <ng-template> -->
                                {{ currencySymbol
                                }}{{ companypay.amount | number: "1.2-2" }}
                                <!-- </ng-template> -->
                              </td>

                              <td class="grandTotal amounts">
                                <!-- <span *ngIf="companypay.upgradeCalculation;else normaltax">{{ currencySymbol
                                              }}{{ companypay.upgradeCalculation.deltaplanTax | number: "1.2-2" }}</span> -->

                                <!-- <ng-template> -->
                                {{ currencySymbol
                                }}{{ companypay.tax | number: "1.2-2" }}
                                <!-- </ng-template> -->
                              </td>

                              <td class="grandTotal amounts">
                                <!-- <span *ngIf="companypay.upgradeCalculation;else normaltotal">
                                             <b>{{ currencySymbol}}{{ companypay.upgradeCalculation.deltaplanTotal | number: "1.2-2" }}</b></span> -->

                                <!-- <ng-template > -->
                                <b>{{ currencySymbol
                                  }}{{ companypay.total | number: "1.2-2" }}</b>
                                <!-- </ng-template> -->
                              </td>

                            </tr>
                            <tr style="background-color: rgb(20,42,73);color:white"
                              *ngIf="employeeDealingPlansarr.length == 0 ? false : true">

                              <td>{{lang?.Total_charge_to_Employee}}</td>
                              <td></td>

                              <td class="grandTotal amounts">{{ currencySymbol
                                }}{{ empDirectpayPlanamountTotal | number: "1.2-2" }}</td>

                              <td class="grandTotal amounts">{{ currencySymbol
                                }}{{ empDirectpayPlantaxTotal | number: "1.2-2" }}</td>

                              <td class="grandTotal amounts">
                                <b>{{ currencySymbol
                                  }}{{ empDirectpayPlangrandTotal | number: "1.2-2" }}</b>
                              </td>

                            </tr>
                          </tbody>
                        </table>
                        <!-- <table>
                                      <label>Monthly payment Sumamry</label>
                                      <tr></tr>
                                    </table> -->
                      </div>
                    </div>
                  </div>


                  <div class="form-row optclass" *ngIf="alloptinplans && alloptinplans.length == 0 ? false : true">
                    <div class="form-group col-md-12">
                      <label for="cardnumnber"><strong>{{lang?.Opt_in_plans_summary}}</strong></label>

                      <div>
                        <table class="table table-bordered" id="customerPlansTable">
                          <tbody>
                            <tr>
                              <!-- <th>S. no</th> -->
                              <th>{{lang?.Plan}}</th>
                              <th>{{lang?.Details}}</th>
                              <!-- <th class="taxamount"> Amount</th>

                                    <th class="taxamount">Tax</th>
                                    <th class="taxamount">Total</th> -->
                            </tr>
                            <tr *ngFor="
                                          let item of alloptinplans;
                                          let i = index
                                        ">
                              <!-- <td>{{i+1}}</td> -->
                              <!-- {{item.groupName | lowercase}}- -->

                              <td>
                                {{ item.planname }}<br />({{
                                item.packagename
                                }})
                              </td>
                              <td>{{ item.details }}</td>
                              <!-- <td class="taxamount">{{currencySymbol}}{{item.planPrice | number : '1.2-2'}}</td>

                                    <td class="taxamount"><span *ngIf="item.gstCheck" class="gsttaxes">{{item.gstPrice==0?"-":"(GST)&nbsp;"+currencySymbol+(item.gstPrice | number : '1.2-2')}}</span><span *ngIf="item.pstCheck" class="gsttaxes">{{item.pstPrice==0?"-":"(PST)&nbsp;"+currencySymbol+(item.pstPrice | number : '1.2-2')}}</span><span *ngIf="item.hstCheck"  class="gsttaxes">{{item.hstPrice==0?"-":"(HST)&nbsp;"+currencySymbol+(item.hstPrice | number : '1.2-2')}}</span><span *ngIf="!item.gstCheck && !item.pstCheck && !item.hstCheck ">-</span></td>
                                    <td class="grandTotal">{{currencySymbol}}{{item.totalPrice | number : '1.2-2'}}</td> -->
                            </tr>

                            <tr>
                              <!-- <td>Total </td><td colspan="2"></td><td class="grandTotal">{{currencySymbol}}0.00</td> -->
                            </tr>
                            <!-- <tr>
                                    <td colspan="3">

                                    </td>
                                    <td colspan="2" class="grandTotal">Total:&nbsp;{{currencySymbol}}{{planAmount | number : '1.2-2'}}</td>
                                  </tr> -->
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>



                </div>


              </div>

              <!-- ******************enrollment form start ************* -->
              <form action="https://payments.subscriptionplatform.com/v2/payments/create" method="post"
                #enrollmentForms1 #enrollmentForms="ngForm" [formGroup]="enrollmentForm" class="mt-2">
                <div class="container">

                  <div class="row" *ngIf="employeeDealingPlansarr.length>0">
                    <div class="col-12 mt-1">
                      <label for="" class="mt-1">{{lang?.Payment_Method}}</label>
                      <div class="form-check"><input type="radio" name="paymentMethodSelection"
                          class="form-check-input mt-1" (change)="paymentMethodSelect('Pre-Authorized')"> <label
                          for="">{{lang?.Pre_authorized_Debit}}</label> </div>
                      <div class="form-check"><input type="radio" name="paymentMethodSelection"
                          class="form-check-input border border-dark" (change)="paymentMethodSelect('Credit_Card')"
                          checked>
                        <label for="">{{lang?.Credit_Card}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-12 col-md-6">
                      <!-- <div class="row">
                                    <div class="form-group col-12">
                                      <label for="" class=""> {{lang?.Email}} <span class="text-danger">*</span></label>
                                      <input type="text" class="form-control no-drop border border-dark enrollmentEmailFontClr"
                                        [ngModel]="paymentemail" formControlName="enrollmentSummaryEmail" placeholder="Email"
                                        readonly>
                                    </div>
                                  </div> -->



                      <!-- ************************** Pre-Authorized Debit END ***************************** -->

                    </div>
                  </div>
                  <!-- ************************** Enrollment Form END ***************************** -->
                  <!-- <div class="form-row mt-2" *ngIf="employeeDealingPlansarr.length>0">
                    <div class="form-group d-flex">
                      <input type="checkbox" class="form-check-input border border-dark"
                        formArrayName="homeAddressSameasBillingAddress" [checked]="homeaddresscheckvalue"
                        (change)="homeaddressEnrollment($event)">
                      <label for="" class="ms-1">{{lang?.Home_address_is_the_same_as_billing_address}}</label>
                    </div>
                  </div> -->

                  <!-- <div *ngIf="paidEmployeedTotalDub>0 && !homeaddressEnrollmentVal">
                    <div class="row">
                      <div class="form-group mt-1 col-12 col-md-6 mt-2">
                        <label for="">{{lang?.Unit_Apt_Suite}}</label>
                        <input type="text" class="form-control border border-dark text-capitalize"
                          placeholder="{{lang?.Unit_Apt_Suite}}" formControlName="enrollmentSummaryApartSuite">
                        <div class="help-block text-danger"
                          *ngIf="enrollmentForm.get('enrollmentSummaryApartSuite')?.touched && enrollmentForm.get('enrollmentSummaryApartSuite')?.hasError('aptexpression')">
                          {{lang?.Please_enter_valid_Unit_Apt_Suite_number}}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6 mt-1">
                        <label for="">{{lang?.Street_Address}} <span class="text-danger">*</span></label>
                        <input type="text" class="form-control border border-dark text-capitalize"
                          placeholder="{{ lang?.Street_Address }}" formControlName="enrollmentSummaryStreetAddress" />


                        <div class="help-block text-danger"
                          *ngIf="(enrollmentForm.get('enrollmentSummaryStreetAddress')?.touched &&
                                  enrollmentForm.get('enrollmentSummaryStreetAddress')?.hasError('required')) ||
                                  (enrollmentForm.get('enrollmentSummaryStreetAddress')?.hasError('required') && enrollmentForms.submitted)">
                          {{ lang?.Please_enter_Street_Address }}
                        </div>

                      </div>
                      <div class="col-12 col-md-6 mt-1">
                        <label for="">{{lang?.Street_Address_Line_2}} </label>
                        <input type="text" class="form-control border border-dark"
                          placeholder="{{lang?.Street_Address_Line_2}}"
                          formControlName="enrollmentSummaryStreetAddressLane2">

                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-md-4 mt-1">
                        <label for="">{{lang?.City}} <span class="text-danger">*</span></label>
                        <input type="text" class="form-control border border-dark text-capitalize"
                          placeholder="{{lang?.City}}" formControlName="enrollmentSummaryCity">


                        <div class="help-block text-danger"
                          *ngIf="(enrollmentForm.get('enrollmentSummaryCity')?.touched &&
                                    enrollmentForm.get('enrollmentSummaryCity')?.hasError('required')) ||
                                    (enrollmentForm.get('enrollmentSummaryCity')?.hasError('required') && enrollmentForms.submitted)">
                          {{ lang?.Please_enter_Street_Address }}
                        </div>

                      </div>

                      <div class="col-12 col-md-4 mt-1">
                        <label for="">{{lang?.Province}} <span class="text-danger">*</span></label>
                        <select type="text" class="form-select border border-dark"
                          formControlName="enrollmentSummaryProvince" (change)="provinceEnrollmentlist($event)">
                          <option value="null" [selected]="!enrollmentFormControl['enrollmentSummaryProvince']?.value">
                            {{lang?.Select}}</option>
                          <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                            {{ name.shortName }}
                          </option>
                        </select>

                        <div class="help-block text-danger" *ngIf="enrollmentFormControl['enrollmentSummaryProvince'].touched &&
                                      enrollmentFormControl['enrollmentSummaryProvince'].invalid">
                          <div
                            *ngIf="enrollmentFormControl['enrollmentSummaryProvince'].errors && enrollmentFormControl['enrollmentSummaryProvince'].errors['required']">
                            {{ lang?.Please_select_Province }}
                          </div>
                        </div>


                      </div>

                      <div class="col-12 col-md-4 mt-1">
                        <label>{{lang?.Postal_Code}} <span class="text-danger">*</span></label>

                        <input type="text" class="form-control checking-field border border-dark"
                          placeholder="{{ lang?.Postal_Code }}" formControlName="enrollmentSummaryPostalCode"
                          (input)="changeTextToUppercaseenrollmentPostalCode('enrollmentSummaryPostalCode',$event)" />

                        <div class="help-block text-danger"
                          *ngIf="(enrollmentForm.get('enrollmentSummaryPostalCode')?.touched &&
                                  enrollmentForm.get('enrollmentSummaryPostalCode')?.hasError('required')) ||
                                        (enrollmentForm.get('enrollmentSummaryPostalCode')?.hasError('required') && enrollmentForms.submitted)">
                          {{ lang?.Please_enter_postal_code }}
                        </div>

                        <div class="help-block text-danger" *ngIf="
                                  (enrollmentForm.get('enrollmentSummaryPostalCode')?.touched &&
                                  enrollmentForm .get('enrollmentSummaryPostalCode')?.hasError('invalidPostalCode')) ||
                                  (!enrollmentForm.get('enrollmentSummaryProvince')?.hasError('required') && invalidenrollmentpostalcodeprovince)
                                ">{{ lang?.Please_enter_valid_postal_code }}</div>


                      </div>




                    </div>
                  </div> -->





                  <!-- <div *ngIf="!paymentMethodSelectCC" class="container mt-4"> signaturePadClear -->
                  <!-- <div  class="container mt-4"> -->
                  <div class="form-row" class="paymentMethodSelectCC">
                    <!-- <div class="col-md-6">
                                  <label for="">{{lang1.signature}} </label>
                                  <div class="signature-pad">
                                    <canvas #signaturePadCanvas
                                      class="border border-darker signature-padBgColour signPad border border-dark"
                                      (touchstart)="startSigning($event)" (click)="startSigning($event)">
                                    </canvas>


                                    <p class="clear-button text-danger underline-text singnaturPad" *ngIf="signaturePadClear"
                                      (click)="clearSignature()"> x Clear</p>


                                  </div>
                                </div> -->
                  </div>
                  <!-- </div> -->
                  <!-- recaptcha box**************************************************** -->

                  <!-- <div class="form-row captchavalidation" *ngIf="paymentMethodSelectCC">
                                <re-captcha
                                  (resolved)="resolved($event)"
                                  formControlName="recaptchaReactive"> {{fusbillinfocaptchavalue}}
                                </re-captcha>

                                <input
                                  id="recaptcha_token"
                                  type="hidden"
                                  name="recaptcha_token"
                                  [value]="recaptchaResponse"
                                />
                                <span
                                    class="help-block text-danger"
                                    style="margin-left: 10px"
                                    *ngIf="
                                    bankPayForm.get('recaptchaReactive')?.touched &&
                                    bankPayForm.get('recaptchaReactive')?.hasError('required')">{{lang1.please_check_captcha_validation}}</span
                                  >
                              </div> -->
                  <!-- <div class="form-row captchavalidation" *ngIf="paymentMethodSelectCC">
                                <re-captcha
                                  (resolved)="resolved($event)"
                                  formControlName="recaptchaReactive"

                                  siteKey={{fusbillinfocaptchavalue}}
                                >
                                </re-captcha>

                                <input
                                  id="recaptcha_token"
                                  type="hidden"
                                  name="recaptcha_token"
                                  [value]="recaptchaResponse" />

                              </div> -->


                </div>
              </form>
            </div>
            <div class="form-row d-flex justify-content-between mt-2">

              <button type="submit" class="saveAndNext" (click)="selectTab('tab2')">
                <i aria-hidden="true" class="fa fa-chevron-left"></i>
                {{lang?.Previous}}
              </button>
              <button type="submit" class="saveAndNext" (click)="enrollmentFormSubmit(enrollmentForms1)">
                {{lang?.Submit}}
              </button>

            </div>



            <!-- *********** enrollment form ended *************** -->
          </div>

        </div>

      </div>
    </div>
  </div>
</main>

<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="QCproviance">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">

    <div class="modal-content">

      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">

        <div class="col-12 text-white text-center">
          {{lang?.Service_Unavailability}}
        </div>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        <!-- <div class="col-1 text-end">
            <i class="fa-solid fa-xmark fa-lg text-white" role="button" (click)="childrenPopupClose()" aria-hidden="true"
              data-bs-dismiss="modal"></i>
          </div> -->
      </div>
      <div class="model-body ms-3 mt-2">
        <p>
          {{lang?.Service_not_available_in_Quebec_presently_Please_check_back_in_2025}}
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-dark buttonSizeNDColor backgroundColor" style="font-size: 14px;border-radius:5px"
          data-bs-dismiss="modal" (click)="closeprovinceinfo()">
          <strong style="color: white" (click)="closePopup('QCproviance')">{{lang?.Close}}</strong>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal modalposition modal-md" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label"
  id="checkuhipstatusModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div
        class="modal-header modalPopupHeaderAndButtonBgColor justify-content-center text-white headerBottomRadius10px">
        <div class="col-1">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
        </div>
        <div class="col-11 text-center">
          <a>{{lang?.Provincial_Health_Coverage}}</a>
        </div>
      </div>
      <div class="modal-body">
        <a>{{lang?.Provincial_health_Coverage_is_a_prerequisite_Please_visit}}
          <a style="word-wrap: break-word;" href="{{ provincialHealthcareUrl }}" target="_blank">
            {{ provincialHealthcareUrl
            }}</a>&nbsp;{{lang?.to_apply_for_provincial_health_coverage_and_reapply_when_it_is_received}}</a>
      </div>
      <div class="modal-footer">
        <button class="btn " data-bs-dismiss="modal">
          {{lang?.Close}}
        </button>
      </div>
    </div>
  </div>
</div>


<div class="modal modalposition modal-md" data-bs-backdrop="static" aria-labelledby="modal-label"
  id="checkphcpstatusModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="z-index:9999 !important">
      <div
        class="modal-header modalPopupHeaderAndButtonBgColor justify-content-center text-white headerBottomRadius10px">
        <div class="col-1 ">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
        </div>
        <div class="col-11 text-center">
          {{lang?.Provincial_Health_Coverage}}

        </div>
      </div>
      <div class="modal-body">
        <!-- <a>
                  {{language.apply_UHIP}}</a> -->
        <p>
          {{lang?.Provincial_health_Coverage_is_a_prerequisite_Please_visit}} <a> {{provincialHealthcareUrl}}</a>
          {{lang?.to_apply_for_provincial_health_coverage_and_reapply_when_it_is_received}}
        </p>
      </div>
      <!-- <div [innerHtml]="sanitizedApplyUHIPHtml"></div> -->
      <div class="modal-footer ">
        <button class="btn btn-primary buttonSizeNDColor text-white closeButton" data-bs-dismiss="modal"
          (click)="closePopup('checkphcpstatusModal')">
          {{lang?.Close}}
        </button>
      </div>
    </div>
  </div>
</div>

<div id="childInfoModal" class="modal modalposition modal-md">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">
        <!-- <div class=""> -->
        <div class="col-11 text-white text-center">
          {{childInfoModalAddAndUpdateButton}} {{lang?.Dependent}}
        </div>
        <div class="col-1 text-end">
          <!-- <i class="fa fa-times-circle text-white" role="button" aria-hidden="true" data-bs-dismiss="modal"></i> -->

          <i class="fa-solid fa-xmark fa-lg text-white closebutton" role="button" (click)="closeAddChildrenPopup()"
            aria-hidden="true" data-bs-dismiss="modal"></i>

        </div>
        <!-- </div> -->
      </div>
      <div class="modal-body p-2">
        <form action="" [formGroup]="childFormGroup" style="padding-left: 15px;padding-right: 15px;">
          <div class="container">

            <div class="row">
              <div class="form-group col-12 col-lg-6 p-1 ">
                <label for="" class="">{{lang?.First_Name}} <span class="text-danger">*</span></label>
                <input class="form-control border border-dark text-capitalize" type="text" placeholder="First Name"
                  formControlName="childInfoFirstName" (keypress)="alphabatesOnly($event)">

                <div class="help-block text-danger"
                  *ngIf="(childFormGroup.get('childInfoFirstName')?.touched  && childFormGroup.get('childInfoFirstName')?.hasError('required'))">
                  <!-- {{lang?.Please_enter_first_name_cp}}  -->
                  {{lang?.Please_enter_first_name}}
                </div>

                <div class="help-block text-danger"
                  *ngIf="(childFormGroup.get('childInfoFirstName')?.touched  && childFormGroup.get('childInfoFirstName')?.hasError('minlength'))">
                  {{lang?.First_Name_minimum_of_1_Character_and_without_numbers}}
                </div>

                <div class="help-block text-danger"
                  *ngIf="(childFormGroup.get('childInfoFirstName')?.touched  && childFormGroup.get('childInfoFirstName')?.hasError('pattern'))">
                  {{shouldtallownumberandspecialcharacters}}
                </div>
              </div>
              <div class="form-group col-12 col-lg-6 p-1">
                <label for="" class="">{{lang?.Last_Name}} <span class="text-danger">*</span></label>
                <input type="text" class="form-control border border-dark text-capitalize" placeholder="Last Name"
                  formControlName="childInfoLastName" (keypress)="alphabatesOnly($event)">
                <div class="help-block text-danger" *ngIf="childInfoControl['childInfoLastName'].touched &&
                       childInfoControl['childInfoLastName'].invalid">
                  <div
                    *ngIf="childInfoControl['childInfoLastName'].errors && childInfoControl['childInfoLastName'].errors['required']">
                    <!-- {{ lang?.Please_enter_last_name_cp }} -->
                    {{lang?.Please_enter_last_name}}
                  </div>

                  <div class="help-block text-danger"
                    *ngIf="(childFormGroup.get('childInfoLastName')?.touched  && childFormGroup.get('childInfoLastName')?.hasError('minlength'))">
                    {{lang?.Last_Name_minimum_of_1_Character_and_without_numbers}}
                  </div>

                  <div
                    *ngIf="childInfoControl['childInfoLastName'].errors && childInfoControl['childInfoLastName'].errors['pattern']">
                    {{shouldtallownumberandspecialcharacters}}
                  </div>

                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="form-group col-12 col-lg-6 p-1">
                <label for="" class="">{{lang?.Gender}} <span class="text-danger">*</span></label>

                <select class="form-control border border-dark" placeholder="Select" formControlName="childInfoGender">
                  <option value="null" [selected]="!childFormGroup.get('childInfoGender')?.value">{{ lang?.Select }}
                  </option>
                  <option value="Male">{{ lang?.Male }}</option>
                  <option value="Female">{{ lang?.Female }}</option>
                  <option value="Non-Binary">{{ lang?.Non_Binary }}</option>
                  <option value="Undisclosed"> {{ lang?.Undisclosed }} </option>
                </select>

                <div class="help-block text-danger" *ngIf="childInfoControl['childInfoGender'].touched &&
                  childInfoControl['childInfoGender'].invalid">
                  <div
                    *ngIf="childInfoControl['childInfoGender'].errors && childInfoControl['childInfoGender'].errors['required']">
                    {{ lang?.Please_select_gender }}
                  </div>
                </div>
              </div>
              <div class="form-group col-12 col-lg-6 p-1">

                <label for="childInfoDOB" class="">{{lang?.Date_of_Birth}}<span class="text-danger">*</span></label>
                <!-- <div>{{childDateOfBirth}}</div> -->
                <input type="text" class="form-control border border-dark" id="childInfoDOB" placeholder="MM-DD-YYYY"
                  formControlName="childInfoDOB" [minDate]="minDatechild" [maxDate]="maxDatechild" bsDatepicker #dp
                  *ngIf="true" value="{{childInfoDOB | date:'MM-dd-yyyy'}}" [(ngModel)]="childInfoDOB"
                  [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" [(bsValue)]="childDateOfBirth"
                  (change)="checkForGraduationDate($event)">

                <!-- <input type="text" class="form-control border border-dark" id="childInfoDOB" placeholder="MM-DD-YYYY"
                  formControlName="childInfoDOB" [minDate]="minDatechild" [maxDate]="maxDatechild" bsDatepicker
                  [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }" (bsValueChange)="checkForGraduationDate($event)"
                  (change)="handleManualInput($event.target.value)"> -->

                <div class="help-block text-danger" *ngIf="childInfoControl['childInfoDOB'].touched &&
                  childInfoControl['childInfoDOB'].invalid">
                  <div
                    *ngIf="childInfoControl['childInfoDOB'].errors && childInfoControl['childInfoDOB'].errors['required']">
                    {{ lang?.Please_Choose_Date_of_Birth }}
                  </div>
                  <div *ngIf="childInfoControl['childInfoDOB'].errors && childInfoControl['childInfoDOB'].errors['childrenminimumAge']">
                    {{lang.Age_must_be_below_21_years}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 mt-1">
                <label for="childDependentInsurence"
                  class="">{{lang?.Is_your_dependent_covered_by_another_Health_and_or_Dental_Insurance_plan}} <span
                    class="text-danger">*</span>
                </label>

                <div class="form-check form-check-inline col-4 col-md-6">
                  <input class="form-check-input border border-dark" value="true" type="radio"
                    name="DependentchildInsurence" formControlName="DependentchildInsurence"
                    (click)="havingchildrenDependentInsurence($event)" />
                  <label class="form-check-label" for="DependentchildInsurenceyes">{{ lang?.Yes }}</label>
                </div>

                <div class="form-check form-check-inline col-2">
                  <input class="form-check-input border border-dark" value="false" type="radio"
                    name="DependentchildInsurence" formControlName="DependentchildInsurence"
                    (click)="havingchildrenDependentInsurence($event)" />
                  <label class="form-check-label" for="DependentchildInsurenceno">{{ lang?.No}}</label>
                </div>

                <div class="help-block text-danger"
                  *ngIf="childFormGroup.get('DependentchildInsurence')?.touched && childFormGroup.get('DependentchildInsurence')?.hasError('required')">
                  {{lang?.Please_select_option}}
                </div>

              </div>
            </div>

            <div *ngIf="dependentchildInsurenceval" class="row">
              <div class="form-group col-12 col-md-6 pt-1">
                <label for="" class="">{{lang?.Name_Of_The_Carrier}} <span class="text-danger">*</span></label>
                <input type="text" class="form-control border border-dark text-capitalize"
                  placeholder="{{lang?.Name_Of_The_Carrier}}" formControlName="childInfoCarrierName">
                <div class="help-block text-danger"
                  *ngIf="childFormGroup.get('childInfoCarrierName')?.touched && childFormGroup.get('childInfoCarrierName')?.hasError('required')">
                  {{ lang?.Please_enter_name_of_the_carrier }}
                </div>
              </div>
            </div>


            <div class="row mt-2">
              <div class="form-group col-12 paddingLeft6px">
                <input type="checkbox" class="" name="" id="" formControlName="childdisablility"
                  (click)="childdsiablility($event)" />&nbsp;{{
                lang?.Dependent_with_Special_Needs }}&nbsp;

                <i class="fa fa-info-circle" (click)="dependentWithSpecialNeedsShow()"></i>
              </div>
            </div>
            <div class="row mt-2 ">
              <div class="form-group col-12 paddingLeft6px">
                <input type="checkbox" class="" name="" id="" formControlName="childPostGraduate"
                  (click)="enrolledunversity($event)" />&nbsp;{{
                lang?.Post_Secondary_Student }}&nbsp;

                <i class="fa fa-info-circle" (click)="postSecondaryShow()"></i>
              </div>
            </div>

            <div class="form-group col-md-6 mt-1 marginLeft6px" *ngIf="graducationdaycheck">
              <label class="">{{ lang?.Graduation_Day}}<span class="text-danger">*</span></label>
              <input type="text" formControlName="childInfoGraduationday" placeholder="MM-DD-YYYY"
                class="form-control checking-field border border-dark" bsDatepicker #dp
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" [(ngModel)]="childInfoGraduationday"
                value="{{childInfoGraduationday| date:'MM-dd-yyyy'}}" [(bsValue)]="graduationDate"
                [placement]="'top'" />


              <div class="help-block text-danger"
                *ngIf="childFormGroup.get('childInfoGraduationday')?.touched && childFormGroup.get('childInfoGraduationday')?.hasError('required')">
                {{lang?.Please_choose_graduation_date}}
              </div>
              <div class="help-block text-danger"
                *ngIf="childFormGroup.get('childInfoGraduationday')?.touched && childFormGroup.get('childInfoGraduationday')?.hasError('validGraduationDate')">
                {{lang?.Please_ensure_the_graduation_date_is_later_than_the_date_of_birth}}
              </div>
              <div class="help-block text-danger"
                *ngIf="childFormGroup.get('childInfoGraduationday')?.touched && childFormGroup.get('childInfoGraduationday')?.hasError('dateOfBirth')">
                {{lang?.Please_enter_Date_of_Birth}}
              </div>
            </div>
            <div class="d-flex gap-2 justify-content-end mt-2">
              <div class="">
                <button type="submit" class="btn btn-dark buttonBorder modalPopupHeaderAndButtonBgColor text-white p-1"
                  data-bs-dismiss="modal" (click)="closeAddChildrenPopup()">
                  {{lang?.Cancel}}
                </button>
              </div>
              <div class="">
                <button type="submit" class="buttonBorder  saveAndNext text-white p-1" data-bs-dismiss="modal"
                  (click)="childInfoAddData()">{{childInfoModalAddAndUpdateButton}}</button>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>

<!-- <div class="modal"  #advisoranddisclousreModal tabindex="-1" role="dialog" aria-labelledby="modal-label"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">

      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">
        <div class="col-11 text-white text-center">
          {{ lang1.advisor_disclosure }}
        </div>

      </div>
      <div class="model-body Advisordisclousremodel modalHightNdWidth">

        <span *ngIf="pdfvisibleadvisouredisclosure">
          <img src="../../../assets/img/logo/tenor.gif" width="100" style=" display: block;
          margin-left: auto;
          margin-right: auto;
          width: 25%;">
        </span>

        <pdf-viewer [src]="disclosureAgreement" [render-text]="true" [original-size]="false" class="popupPdf"
          (after-load-complete)="AdviserDisclosureloading($event)">

        </pdf-viewer>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary buttonSizeNDColor" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="modal" #termsAndConditionsModal tabindex="-1" role="dialog" aria-labelledby="modal-label"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">

      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">
        <div class="col-11 text-white text-center">
          {{ lang1.terms__conditions }}
        </div>

      </div>

      <div class="model-body termsandcodionsmodel">
        <span *ngIf="pdfvisibletermsandcodionsmodel">
          <img src="../../../assets/img/logo/tenor.gif" width="100" style=" display: block;
          margin-left: auto;
          margin-right: auto;
          width: 25%;">
        </span>

        <pdf-viewer [src]="term_and_conditions" [render-text]="true" [original-size]="false" class="popupPdf"
          (after-load-complete)="termAndConditionsLoading($event)"></pdf-viewer>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary buttonSizeNDColor " data-bs-dismiss="modal">Close</button>

      </div>
    </div>
  </div>
</div> -->


<!-- </div> -->



<!-- <div class="modal modal-lg" data-backdrop="static" data-keyboard="false" id="showplanoptions-modal"
  style="max-width: 100% !important; ">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable p-2" id="modal-dialog">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title ">{{lang?.Choose_Options}}</span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
          (click)="closeoptionsselection()"></i>
      </div>
      <div class="model-body" style="max-width: 800px;

          overflow-y: scroll;">


        <input type="hidden" id="plandetailsobj" value="{{plandetailsobjvalue}}">
        <input type="hidden" id="optionumber" value="{{optionstitle.length}}">

        <div class="p-2" *ngFor="let option of optionstitle; let i = index" style="max-height: 350px;
            overflow-y: scroll;">
          <span></span>
          <span><b>{{option?.name}}</b><span style="color: red">*</span></span>



          <div *ngFor="let optionvalue of option.planOptionsValues; let j = index">
            <div class="row">
              <div class="col-md-12" style="border: 1px solid black;padding:5px 15px;border-bottom:1px !important">
                <input type="radio" name="{{option.id}}" value="{{optionvalue.json}}"
                  id="planselectionvalue-{{optionvalue.id}}-{{option.id}}" class="optionselectionmethod-{{option.id}}"
                  (click)="planoptionselection($event,optionvalue,option.id,optionvalue.id)">&nbsp;{{optionvalue?.name}}

              </div>
            </div>
          </div>
          <br>
        </div>


      </div>

      <div class="modal-footer">
        <p id="planoptionmessage" style="color:red"><b>{{optionmessage}}</b></p>
        <button type="button" class="btn btn-sm btn-light closebutton" data-bs-dismiss="modal"
          (click)="closeoptionsselection()" id="cancelButton"><b>Close</b></button>

        <button type="button" class="btn btn-sm btn-light"
          (click)="confirmoptionsselection()"><b>{{lang?.Confirm}}</b></button>
      </div>
    </div>
  </div>
</div> -->

<div class="modal fade bd-example-modal-lg" id="showplanoptions-modal" tabindex="-1" role="dialog" *ngIf="showoptions"
  aria-labelledby="showplanoptions-modal" aria-hidden="true">
  <!-- <div class="modal-dialog" role="document"> -->
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="showplanoptions-modal">{{lang.Choose_Options}}</h5>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
          (click)="closeoptionsselection()"></i>
      </div>
      <div class="modal-body">
        <!-- Modal Content -->
        <!-- <input type="hidden" id="plandetailsobj" value="{{plandetailsobjvalue}}">
        <input type="hidden" id="optionumber" value="{{optionstitle.length}}"> -->
                      <input type="hidden" id="plandetailsobj" #optionPlanDetailsObj value="{{plandetailsobjvalue}}">
                      <input type="hidden" id="optionumber" #optionNumberInput value="{{optionstitle.length}}">
        <div *ngFor="let option of optionstitle; let i = index" style="max-height: 350px; overflow-y: scroll;">
          <span></span>
          <span><b>{{option.name}}</b><span style="color: red">*</span></span>
          <div *ngFor="let optionvalue of option.planOptionsValues; let j = index">
            <div class="row">
              <div class="col-md-12" style="border: 1px solid black; padding: 5px 15px;">
                <input type="radio" name="{{option.id}}" value="{{optionvalue.json}}"
                  id="planselectionvalue-{{optionvalue.id}}-{{option.id}}" class="optionselectionmethod-{{option.id}}"
                  (click)="planoptionselection($event,optionvalue,option.id,optionvalue.id)">
                &nbsp;{{optionvalue.name}}
              </div>
            </div>
          </div>
          <br>
        </div>

      </div>
      <div class="modal-footer">
        <p id="planoptionmessage"><b>{{optionmessage}}</b></p>
        <button type="button" class="btn" data-bs-dismiss="modal" (click)="closeoptionsselection()" id="cancelButton">
          <b>{{lang.Close}}</b>
        </button>
        <button type="button" class="btn btn-sm btn-light" (click)="confirmoptionsselection()">
          <b>{{lang.Confirm}}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" data-bs-backdrop="static" id="postSecondaryStudent">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header modalPopupHeaderAndButtonBgColor text-white justify-content-center text-center">
        <div class="col-1">
          <i class="fa fa-info-circle" aria-hidden="true"></i>

        </div>
        <div class="col-11 justify-content-center">
          <b> {{ lang?.Post_Secondary_Student }}</b>

        </div>
      </div>
      <div class="modal-body">
        <p class="ms-2">
          {{ lang?.Enrolled_full_time_in_and_attending_an_accredited_college_university_or_educational_institution }}
        </p>

        <div class="modal-footer">
          <button class="btn " data-bs-dismiss="modal" (click)="closePopup('postSecondaryStudent')">
            <strong style="color: white">{{ lang?.Close }}</strong>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="dependentWithSpecialNeeds" data-bs-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header modalPopupHeaderAndButtonBgColor text-white justify-content-center text-center">
        <div class="col-1">
          <i class="fa fa-info-circle" aria-hidden="true"></i>

        </div>
        <div class="col-11 justify-content-center">
          <b> {{ lang?.Dependent_with_Special_Needs }}</b>

        </div>
      </div>
      <div class="modal-body">
        <p class="ms-2">
          {{
          lang?.Coverage_for_disabled_dependent_children_will_be_based_on_the_definition_in_the_specific_insurer_s_master_contract_You_will_be_contacted_for_additional_information_once_your_application_has_been_received
          }}
        </p>

        <div class="modal-footer">
          <button class="btn " data-bs-dismiss="modal" (click)="closePopup('dependentWithSpecialNeeds')">
            <strong style="color: white">{{ lang?.Close }}</strong>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="gsPlans">
  <div class="modal-dialog modal-dialog-centered " role="document">

    <div class="modal-content">

      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">

        <div class="col-11 text-white text-center">
          {{lang?.Info}}
        </div>
        <!-- <i class="bi bi-x-circle text-white" role="button" aria-hidden="true" data-bs-dismiss="modal"></i> -->

      </div>
      <div class="model-body px-2 py-3" style="font-family: sans-serif;">
        <div [formGroup]="greenShiledForm">
          <div class="row">
            <div>
              <label
                for="greenShiledNumber">{{lang?.The_selection_includes_GreenShield_plans_Do_you_want_to_provision_in_GreenShield}}</label>
            </div>
          </div>
          <div class="row">
            <div>
              <input class="form-check-input border border-dark" type="radio" formControlName="showGreenShieldProv"
                name="showGreenShieldProv" value="false" (click)="changeShowGreenShieldProv($event)" label="name" />
              <label class="form-check-label pe-4 ps-1" for="foreignStudentyes">{{lang?.Yes }}, Provision</label>
              <input class="form-check-input border border-dark" type="radio" formControlName="showGreenShieldProv"
                name="showGreenShieldProv" value="true" (click)="changeShowGreenShieldProv($event)" label="name" />
              <label class="form-check-label ps-1" for="foreignStudentyes">{{lang?.No_already_provisioned}}</label>
              <div class="help-block text-danger" *ngIf="greenShiledForm.get('showGreenShieldProv').touched">
                <div *ngIf="greenShiledForm.get('showGreenShieldProv').hasError('required')">
                  {{lang?.Please_Select_GreenShield_provisioning_choice}}
                </div>
              </div>
            </div>
          </div>


          <div class="row pt-2" *ngIf="showGreenShiled">
            <div class="col-md-5">
              <label for="greenShiledNumber">GreenShield Membership Id</label>
            </div>
            <div class="col-md-5">
              <input type="text" class="form-control checking-field border border-dark"
                formControlName="greenShiledNumber" name="greenShiledNumber" label="name" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-5"></div>
            <div class="col-md-7">
              <div class="help-block text-danger"
                *ngIf="greenShiledForm.get('greenShiledNumber').touched&&showGreenShiled">
                <div *ngIf="greenShiledForm.get('greenShiledNumber').hasError('required')">
                  {{lang?.Please_enter_greenshield_membership_Id}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn " (click)="closeFormPopup('gsPlans',greenShiledForm)" data-bs-dismiss="modal">
          {{lang?.Close}}</button>
        <button class="btn btn-dark buttonSizeNDColor backgroundColor gsPlans"
          (click)="saveGsPlans('gsPlans')">{{lang?.Save}}</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="eqPlans">
  <div class="modal-dialog modal-dialog-centered " role="document">

    <div class="modal-content">

      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">

        <div class="col-11 text-white text-center">
          Info
        </div>
        <!-- <i class="bi bi-x-circle text-white" role="button" aria-hidden="true" data-bs-dismiss="modal"></i> -->

      </div>
      <div class="model-body px-2 py-3" style="font-family: sans-serif;">
        <div [formGroup]="EquitableForm">
          <div class="row">
            <div>
              <label
                for="EquitableFormProv">{{lang?.The_selection_includes_Equitable_plans_Do_you_want_to_provision_in_Equitable}}</label>
            </div>
          </div>
          <div class="row">
            <div>
              <input class="form-check-input border border-dark" type="radio" formControlName="EquitableFormProv"
                name="EquitableFormProv" value="false" (click)="changeShowEquitableProv($event)" label="name" />
              <label class="form-check-label pe-4 ps-1" for="foreignStudentyes">{{lang?.Yes }}, Provision</label>
              <input class="form-check-input border border-dark" type="radio" formControlName="EquitableFormProv"
                name="EquitableFormProv" value="true" (click)="changeShowEquitableProv($event)" label="name" />
              <label class="form-check-label ps-1" for="foreignStudentyes">{{
                lang?.No_already_provisioned}}</label>
              <div class="help-block text-danger" *ngIf="EquitableForm.get('EquitableFormProv').touched">
                <div *ngIf="EquitableForm.get('EquitableFormProv').hasError('required')">
                  {{lang?.Please_Select_Equitable_provisioning_choice}}
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="showEquitable">
            <div class="col-md-5">
              <label for="EquitableNumber">{{lang?.Equitable_Certifciate_Id}}</label>
            </div>
            <div class="col-md-5">
              <input type="text" class="form-control checking-field border border-dark"
                formControlName="EquitableNumber" name="EquitableNumber" label="name" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-5"></div>
            <div class="col-md-7">
              <div class="help-block text-danger" *ngIf="EquitableForm.get('EquitableNumber').touched">
                <div *ngIf="EquitableForm.get('EquitableNumber').hasError('required')">
                  {{lang?.Please_enter_Equitable_certificate_Id}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn " (click)="closeFormPopup('eqPlans',EquitableForm)" data-bs-dismiss="modal">{{lang?.Close}}
        </button>
        <button class="btn btn-dark buttonSizeNDColor backgroundColor gsPlans"
          (click)="saveeqPlans('eqPlans')">{{lang?.Save}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="cwPlans">
  <div class="modal-dialog modal-dialog-centered" role="document">

    <div class="modal-content">

      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">

        <div class="col-11 text-white text-center">
          {{lang?.Info}}
        </div>
        <!-- <i class="bi bi-x-circle text-white" role="button" aria-hidden="true" data-bs-dismiss="modal"></i> -->

      </div>
      <div class="model-body px-2 py-3" style="font-family: sans-serif;">
        <div [formGroup]="cowanForm">
          <div class="row">
            <div>
              <label
                for="greenShiledNumber">{{lang?.The_selection_includes_Provincial_Health_Replacement_Plan_Do_you_want_to_provision_in_Cowan}}</label>
            </div>
          </div>
          <div class="row">
            <div>
              <input class="form-check-input border border-dark" type="radio" formControlName="cowanFormProv"
                name="cowanFormProv" value="false" (click)="changeShowCowanProv($event)" label="name" />
              <label class="form-check-label pe-4 ps-1" for="foreignStudentyes">{{lang?.Yes }}, Provision</label>
              <input class="form-check-input border border-dark" type="radio" formControlName="cowanFormProv"
                name="cowanFormProv" value="true" (click)="changeShowCowanProv($event)" label="name" />
              <label class="form-check-label ps-1" for="foreignStudentyes">{{
                lang?.No_already_provisioned}}</label>
              <div class="help-block text-danger" *ngIf="cowanForm.get('cowanFormProv').touched">
                <div *ngIf="cowanForm.get('cowanFormProv').hasError('required')">
                  {{lang?.Please_Select_PHR_provisioning_choice}}
                </div>
              </div>
            </div>
          </div>


          <div class="row pt-2" *ngIf="showCowan">
            <div class="col-md-5">
              <label for="cowanNumber">{{lang?.PHR_Membership_Id}}</label>
            </div>
            <div class="col-md-5">
              <input type="text" class="form-control checking-field border border-dark" formControlName="cowanNumber"
                name="cowanNumber" label="name" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-5"></div>
            <div class="col-md-7">
              <div class="help-block text-danger" *ngIf="cowanForm.get('cowanNumber').touched&&showCowan">
                <div *ngIf="cowanForm.get('cowanNumber').hasError('required')">
                  {{lang?.Please_enter_PHR_membership_Id}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn" (click)="closeFormPopup('cwPlans',cowanForm)" data-bs-dismiss="modal">
          {{lang?.Close}}</button>
        <button class="btn btn-dark buttonSizeNDColor backgroundColor gsPlans"
          (click)="savecwPlans('cwPlans')">{{lang?.Save}}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="confirmwelcomeemail">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">

    <div class="modal-content">

      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">

        <div class="col-11 text-white text-center">
          {{lang?.Info}}
        </div>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>

      </div>
      <div class="model-body ms-3 mt-2" style="font-family: sans-serif;">
        <div [formGroup]="InvitationForm">
          <div class="row">
            <div>
              <label
                for="invitationStatus">{{lang?.Send_welcome_email_with_Member_Portal_link_upon_successful_enrollment}}</label>
            </div>
          </div>
          <div class="row">
            <div>
              <input class="form-check-input border border-dark" type="radio" formControlName="invitationStatus"
                name="invitationStatus" value="true" (click)="changeinvitationemail($event)" label="name" />
              <label class="form-check-label pe-4 ps-1" for="foreignStudentyes">{{lang?.Yes }}.</label>
              <input class="form-check-input border border-dark" type="radio" formControlName="invitationStatus"
                name="invitationStatus" value="false" (click)="changeinvitationemail($event)" label="name" />
              <label class="form-check-label pe-4 ps-1" for="foreignStudentyes">{{lang?.No}}.</label>
              <input class="form-check-input border border-dark" type="radio" formControlName="invitationStatus"
                name="invitationStatus" value="Other" (click)="changeinvitationemail($event)" label="name" />
              <label class="form-check-label ps-1" for="foreignStudentyes">Alternate Email</label>
              <div class="help-block text-danger" *ngIf="InvitationForm.get('invitationStatus').touched">
                <div *ngIf="InvitationForm.get('invitationStatus').hasError('required')">
                  {{lang?.Please_Select_invitation_mail_choice}}
                </div>
              </div>
            </div>
          </div>


          <div class="row" *ngIf="showinvitationmail">
            <div class="col-md-5">
              <label for="EquitableNumber">{{lang?.Email}}</label>
            </div>
            <div class="col-md-5">
              <input type="text" class="form-control checking-field border border-dark"
                formControlName="invitationEmail" name="invitationEmail" label="name" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-5"></div>
            <div class="col-md-7">
              <div class="help-block text-danger" *ngIf="InvitationForm.get('invitationEmail').touched">
                <div *ngIf="InvitationForm.get('invitationEmail').hasError('required')">
                  {{lang?.Please_enter_email_Id}}
                </div>
                <div class="help-block text-danger" *ngIf="InvitationForm.get('invitationEmail')?.hasError('pattern')">
                  {{ lang?.Please_enter_valid_email }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn " (click)="closeFormPopup('confirmwelcomeemail',InvitationForm)"
          data-bs-dismiss="modal">{{lang?.Close}}
        </button>
        <button class="btn btn-dark buttonSizeNDColor backgroundColor gsPlans"
          (click)="sendwelcomeinvitation('InvitationForm')">{{lang?.Save}}</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="kixPlans">
  <div class="modal-dialog modal-dialog-centered " role="document">

    <div class="modal-content">

      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">

        <div class="col-11 text-white text-center">
          {{lang.Info}}
        </div>
        <!-- <i class="bi bi-x-circle text-white" role="button" aria-hidden="true" data-bs-dismiss="modal"></i> -->

      </div>
      <div class="model-body px-2 py-3" style="font-family: sans-serif;">
        <div [formGroup]="KixCareForm">
          <div class="row">
            <div>
              <label
                for="KixCareFormProv">{{lang.The_selection_includes_KixCare_plans_Do_you_want_to_provision_in_KixCare}}</label>
            </div>
          </div>
          <div class="row">
            <div>
              <input class="form-check-input border border-dark" type="radio" formControlName="KixCareFormProv"
                name="KixCareFormProv" value="false" (click)="changeKixCareProv($event)" label="name" />
              <label class="form-check-label pe-4 ps-1" for="foreignStudentyes">{{lang.Yes }},
                {{lang.Provision}}</label>
              <input class="form-check-input border border-dark" type="radio" formControlName="KixCareFormProv"
                name="KixCareFormProv" value="true" (click)="changeKixCareProv($event)" label="name" />
              <label class="form-check-label ps-1" for="foreignStudentyes">{{
                lang.No}}, {{lang.already_provisioned}}</label>
              <div class="help-block text-danger" *ngIf="KixCareForm.get('KixCareFormProv').touched">
                <div *ngIf="KixCareForm.get('KixCareFormProv').hasError('required')">
                  {{lang.Please_Select_KixCare_provisioning_choice}}
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="row" *ngIf="showKixcarePlans">
            <div class="col-md-5">
              <label for="KixCareNumber">KixCare Certifciate Id</label>
            </div>
            <div class="col-md-5">
              <input type="text" class="form-control checking-field border border-dark"
                formControlName="KixCareNumber" name="KixCareNumber" label="name" />
            </div>
          </div> -->
          <!-- <div class="row">
            <div class="col-md-5"></div>
            <div class="col-md-7">
              <div class="help-block text-danger" *ngIf="KixCareForm.get('KixCareNumber').touched">
                <div *ngIf="KixCareForm.get('KixCareNumber').hasError('required')">
                  Please enter KiXCare certificate Id.
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn " (click)="closeFormPopup('kixPlans',KixCareForm)" data-bs-dismiss="modal">{{lang.Close}}
        </button>
        <button class="btn btn-dark buttonSizeNDColor backgroundColor gsPlans"
          (click)="saveKixCarePlans('kixPlans')">{{lang.Save}}</button>
      </div>
    </div>
  </div>
</div>
<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="waddellPlans">
  <div class="modal-dialog modal-dialog-centered " role="document">

    <div class="modal-content">

      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">

        <div class="col-11 text-white text-center">
          {{lang.Info}}
        </div>
        <!-- <i class="bi bi-x-circle text-white" role="button" aria-hidden="true" data-bs-dismiss="modal"></i> -->

      </div>
      <div class="model-body px-2 py-3" style="font-family: sans-serif;">
        <div [formGroup]="waddellPlanForm">
          <div class="row">
            <div>
              <label
                for="waddellFormProv">{{lang.This_selection_Include_waddell_plan_Do_you_want_to_provision_in_waddell}}</label>
            </div>
          </div>
          <div class="row">
            <div>
              <input class="form-check-input border border-dark" type="radio" formControlName="waddellFormProv"
                name="waddellFormProv" value="false" (click)="changeWaddellProv($event)" label="name" />
              <label class="form-check-label pe-4 ps-1" for="foreignStudentyes">{{lang.Yes }},
                {{lang.Provision}}</label>
              <input class="form-check-input border border-dark" type="radio" formControlName="waddellFormProv"
                name="waddellFormProv" value="true" (click)="changeWaddellProv($event)" label="name" />
              <label class="form-check-label ps-1" for="foreignStudentyes">{{
                lang.No}}, {{lang.already_provisioned}}</label>
              <div class="help-block text-danger" *ngIf="waddellPlanForm.get('waddellFormProv').touched">
                <div *ngIf="waddellPlanForm.get('waddellFormProv').hasError('required')">

                  {{lang.Please_select_the_waddell_Provision_choice}}
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="row" *ngIf="showKixcarePlans">
            <div class="col-md-5">
              <label for="KixCareNumber">KixCare Certifciate Id</label>
            </div>
            <div class="col-md-5">
              <input type="text" class="form-control checking-field border border-dark"
                formControlName="KixCareNumber" name="KixCareNumber" label="name" />
            </div>
          </div> -->
          <!-- <div class="row">
            <div class="col-md-5"></div>
            <div class="col-md-7">
              <div class="help-block text-danger" *ngIf="KixCareForm.get('KixCareNumber').touched">
                <div *ngIf="KixCareForm.get('KixCareNumber').hasError('required')">
                  Please enter KiXCare certificate Id.
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn " (click)="closeFormPopup('waddellPlans',waddellPlanForm)"
          data-bs-dismiss="modal">{{lang.Close}}
        </button>
        <button class="btn btn-dark buttonSizeNDColor backgroundColor gsPlans"
          (click)="saveWaddellPlans('waddellPlans')">{{lang.Save}}</button>
      </div>
    </div>
  </div>
</div>
<!-- flex plans -->
<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="flexPlans">
  <div class="modal-dialog modal-dialog-centered " role="document">

    <div class="modal-content">

      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">

        <div class="col-11 text-white text-center">
          {{lang.Info}}
        </div>
        <!-- <i class="bi bi-x-circle text-white" role="button" aria-hidden="true" data-bs-dismiss="modal"></i> -->

      </div>
      <div class="model-body px-2 py-3" style="font-family: sans-serif;">
        <div [formGroup]="FlexForm">
          <div class="row">
            <div>
              <label
                for="FlexFormProv">
                <!-- {{lang.The_selection_includes_KixCare_plans_Do_you_want_to_provision_in_KixCare}} -->
                This selection includes Flex plans,do you want to provision in the Greenshield?
              </label>
            </div>
          </div>
          <div class="row">
            <div>
              <input class="form-check-input border border-dark" type="radio" formControlName="FlexFormProv"
                name="FlexFormProv" value="false" (click)="changeFlexPlanProv($event)" label="name" />
              <label class="form-check-label pe-4 ps-1" for="foreignStudentyes">{{lang.Yes }},
                {{lang.Provision}}</label>
              <input class="form-check-input border border-dark" type="radio" formControlName="FlexFormProv"
                name="FlexFormProv" value="true" (click)="changeFlexPlanProv($event)" label="name" />
              <label class="form-check-label ps-1" for="foreignStudentyes">{{
                lang.No}}, {{lang.already_provisioned}}</label>
              <div class="help-block text-danger" *ngIf="FlexForm.get('FlexFormProv').touched">
                <div *ngIf="FlexForm.get('FlexFormProv').hasError('required')">
                  Please select flex provisiong choice
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="showFlexPlans">
            <div class="col-md-5">
              <label for="FlexMembershipId">Greenshield certificate id</label>
            </div>
            <div class="col-md-5">
              <input type="text" class="form-control checking-field border border-dark"
                formControlName="FlexMembershipId" name="FlexMembershipId" label="name" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-5"></div>
            <div class="col-md-7">
              <div class="help-block text-danger" *ngIf="FlexForm.get('FlexMembershipId').touched">
                <div *ngIf="FlexForm.get('FlexMembershipId').hasError('required')">
                  Please enter Flex certificate Id.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn " (click)="closeFormPopup('flexPlans',FlexForm)" data-bs-dismiss="modal">{{lang.Close}}
        </button>
        <button class="btn btn-dark buttonSizeNDColor backgroundColor gsPlans"
          (click)="saveFlexPlans('flexPlans')">{{lang.Save}}</button>
      </div>
    </div>
  </div>
</div>
